// import axios from "axios";
// import React, { useRef, useState, useEffect, useContext } from "react";
// import { useHistory, useLocation } from "react-router-dom";
// import css from "../css/Addcase.module.css";
// import Compressor from "compressorjs";
// import css1 from "../css/Pan.module.css";
// import Rightcontainer from "../Components/Rightcontainer";
// import "../css/Loader.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/viewGame1.css";
// import "../css/layout.css";
// import buttonIcon from '../../assets/images/youtube.png';
// import Swal from "sweetalert2";
// import Header from "../Components/Header";
// import socket from "../Components/socket";
// import "../css/landing.css";
// import Modal from "react-bootstrap/Modal";
// import { BsArrowRight, BsQrCodeScan } from "react-icons/bs";
// import DownloadLink from "react-download-link";
// import Spinner from "react-bootstrap/Spinner";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { apiRequest } from "../../apiService/allApi";

// const Addcase = ({ walletUpdate }) => {
//   // BASE URL

//   // const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   // const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   // const nodeMode = process.env.NODE_ENV;
//   // if (nodeMode === "development") {
//   //   var baseUrl = beckendLocalApiUrl;
//   // } else {
//   //   baseUrl = beckendLiveApiUrl;
//   // }

//   const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   // +++++++++++++++++++++++++++++

//   const history = useHistory();
//   let method = useRef();
//   let checkInterval;
//   const [userAllData, setUserAllData] = useState();

//   const access_token = localStorage.getItem("token");

//   const [isLoading1, setIsloading1] = useState(false); 
//   const [global, setGlobal] = useState(100);
//   const [next, setNext] = useState(1);
//   const [process1, setProcess] = useState(false);
//   const [isMobile, setMobile] = useState(false);

//   const [isCashFreeActive, setCashFreeActive] = useState(true);
//   const [isPhonePayActive, setIsPhonePayActive] = useState(false);
//   const [isAirPayActive, setIsAirPayActive] = useState(false);
//   const [payinOne, setPayinOne] = useState(false);
//   const [payinTwo, setPayinTwo] = useState(false);
//   const [isUpiGateway, setUpiGateway] = useState(false);
//   const [isUpiGateway02, setUpiGateway02] = useState(false);
//   const [isUpiGateway03, setUpiGateway03] = useState(false);
//   const [isMyPayActive, setIsMyPayActive] = useState(false);
//   const [isPineLabActive, setPineLabActive] = useState(false);
//   const [isRazorPayActive, setRazorPayActive] = useState(false);
//   const [isDecentroActive, setDecentroActive] = useState(false);
//   const [isHoadaPaypayInActive, setHoadaPaypayInActive] = useState(false);
//   const [ManualPaymentdata, setManualPaymentdata] = useState([]);

//   const [manualData, setManualData] = useState([]);
//   const [PayOneImage, setPayOneImage] = useState("");
//   const [PayTwoImage, setPayTwoImage] = useState("");
//   const [PayThreeImage, setPayThreeImage] = useState("");
//   const [PayFourImage, setPayFourImage] = useState("");
//   const [PayFiveImage, setPayFiveImage] = useState("");

//   // hooks for payment url
//   const [PayNow1Url, setPaynow1Url] = useState("");
//   const [PayNow2Url, setPaynow2Url] = useState("");
//   const [PayNow3Url, setPaynow3Url] = useState("");
//   const [PayNow4Url, setPaynow4Url] = useState("");
//   const [PayNow5Url, setPaynow5Url] = useState("");

//   const [show_won, setShow_won] = useState(false);
//   const handleClose_won = () => setShow_won(false);
//   const [scrnshot, setScrnshot] = useState(null);
//   const [fecthStatus, setFecthStatus] = useState();
//   const [scrnshot1, setScrnshot1] = useState("");
//   const handleShow_won = () => setShow_won(true);

//   const [qrCode, setQrCode] = useState();
//   const [walletOption, setWalletOption] = useState("airtel");
//   const [bankCode, setBankCode] = useState(3003);

//   const [account_mail_id, setAccount_mail_id] = useState();
//   const [account_name, setAccount_name] = useState();
//   const [accountPhone, setAccountPhone] = useState();
//   const [isLoading, setIsLoading] = useState(false);

//   const [minLimit, setMinLimit] = useState(null);
//   const [maxLimit, setMaxLimit] = useState(null);
//   const [amount, setamount] = useState("");
//   const [utr, setutr] = useState("");
//   const [pgUpiGateway, setPGGateway] = useState(false);

//   // console.log(maxLimit)

//   const addsetting = localStorage.getItem("sitSetting");
//   const addCaseSetting = JSON.parse(addsetting);


//   // Hoada Hooks

//   const [hoadaPay, setHoadaPay] = useState(false);

//   useEffect(() => {
//     setMinLimit(addCaseSetting.depositlimitMin);
//     setMaxLimit(addCaseSetting.depositlimitMax);

//     if (!addCaseSetting.isDeposit) {
//       <script>

//         document.getElementById("addcase").style.display = "none";
//         document.getElementById("depositClose").style.display = "block";
//       </script>
//     }
//   }, []);

//   const handleNext = () => {
//     if (global < minLimit || global > maxLimit) {
//       Swal.fire({
//         title: `Minimum amount should be greater than ${minLimit} and maximum amount should be less than ${maxLimit}`,

//         confirmButtonText: "OK",
//         content: "custom-swal-content",
//       });
//     } else {
//       setNext(2);
//     }
//   };

//   //Function to load razorpay script for the display of razorpay payment SDK.
//   function loadRazorpayScript(src) {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = src;
//       script.onload = () => {
//         resolve(true);
//       };
//       script.onerror = () => {
//         resolve(false);
//       };
//       document.body.appendChild(script);
//     });
//   }

//   //function will get called when clicked on the pay button.
//   async function displayRazorpayPaymentSdk(
//     channel,
//     method,
//     upiMethod,
//     razorpay
//   ) {
//     const res = await loadRazorpayScript(
//       "https://checkout.razorpay.com/v1/checkout.js"
//     );

//     if (!res) {
//       alert("Razorpay SDK failed to load. please check are you online?");
//       return;
//     }
//     //setProcess(true);
//     const access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };
//     // creating a new order and sending order ID to backend
//     // const response = await axios.post(
//     //   baseUrl + "user/razorpay_order",
//     //   {
//     // amount: global,
//     // channel: channel,
//     // payment_method: method,
//     // provider: walletOption,
//     // bankCode: bankCode,
//     // account_name: account_name,
//     // payment_gatway: razorpay,
//     //   },
//     //   { headers }
//     // );
//     let alldata = {
//       amount: global,
//       channel: channel,
//       payment_method: method,
//       provider: walletOption,
//       bankCode: bankCode,
//       account_name: account_name,
//       payment_gatway: razorpay,
//     }

//     const response = await apiRequest('user/razorpay_order', "POST", alldata, headers)

//     if (!response) {
//       alert("Server error. please check are you onlin?");
//       return;
//     }

//     // Getting the order details back
//     let order_id = response.data.txnID;
//     let order_token = response.data.orderdata.id;
//     const data = response.data.orderdata;
//     const options = {
//       key: "rzp_live_hmxBSXgEqtBqJq",
//       name: "Rk Ludo",
//       description: "Skill Based Game Tournament",
//       order_id: data.id,
//       prefill: {
//         name: account_name,
//         email: account_mail_id,
//         contact: accountPhone,
//       },
//       handler: async (response) => {
//         //console.log(response)
//         try {
//           const paymentId = response.razorpay_payment_id;

//           checkrazorpaydeposit(order_id, order_token, "SUCCESS", paymentId);
//         } catch (err) {
//           checkrazorpaydeposit(order_id, order_token, "FAILED");
//           console.log(err);
//         }
//       },
//       theme: {
//         color: "#686CFD",
//       },
//     };

//     const paymentObject = new window.Razorpay(options);
//     paymentObject.open();
//   }

//   const checkrazorpaydeposit = async (
//     order_id,
//     order_token,
//     order_status,
//     paymentId
//   ) => {
//     const access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };
//     // axios
//     // .post(
//     //   baseUrl + `razorpaydesposit/response`,
//     //   { order_id, order_token, order_status, paymentId },
//     //   { headers }
//     // )
//     let alldeta2 = {
//       order_id, order_token, order_status, paymentId
//     }

//     const response = await apiRequest('user/razorpay_order', "POST", alldeta2, headers)


//     // .then((res) => {
//     const icon = response.data.status == "PAID" ? "success" : "danger";
//     const title =

//       response.data.status == "PAID"
//         ? "Deposit submited successfully"
//         : "Transaction Failed";
//     history.push("/");
//     setTimeout(() => {
//       Swal.fire({
//         title: title,
//         icon: icon,
//         confirmButtonText: "OK",
//       });
//     }, 1000);
//     // })
//     // .catch((e) => {
//     // if (e.response.status == 401) {
//     //   localStorage.removeItem("token");
//     //   localStorage.removeItem("token");
//     //   window.location.reload();
//     // }
//     // });
//   };

//   // upigateway
//   const upigateway = async () => {

//     setProcess(true)
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     }

//     const respone = await apiRequest(`user/depositeupi?amount=${global.toFixed(2)}`, "POST", { amount: global }, headers)

//     // .then((res) => {
//     if (respone.data.data.status) {
//       // console.log(res.data.data.data.payment_url)
//       // console.log(res.data.data.data.order_id)
//       let order_id = respone.data.txnID
//       let order_token = respone.data.data.data.order_id
//       //setProcess(false);
//       window.open(respone.data.data.data.payment_url)
//       setTimeout(() => {
//         checkupideposit(order_id, order_token)
//         setProcess(false)
//       }, 60000)
//     } else {
//       setProcess(false)
//       Swal.fire({
//         title: respone.data.data.msg,
//         icon: 'danger',
//         confirmButtonText: 'OK',
//       })
//     }
//     // // })
//     // .catch((e) => {
//     //   alert(e)
//     // })

//   }

//   // upigateway2
//   const upigateway02 = async () => {

//     setProcess(true)
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     }

//     const respone = await apiRequest(`user/depositeupi02?amount=${global.toFixed(2)}`, "POST", { amount: global }, headers)


//     // .then((res) => {
//     if (respone.data.data.status) {
//       // console.log(res.data.data.data.payment_url)
//       // console.log(res.data.data.data.order_id)
//       let order_id = respone.data.txnID
//       let order_token = respone.data.data.data.order_id
//       //setProcess(false);
//       window.open(respone.data.data.data.payment_url)
//       setTimeout(() => {
//         checkupideposit(order_id, order_token)
//         setProcess(false)
//       }, 60000)
//     } else {
//       setProcess(false)
//       Swal.fire({
//         title: respone.data.data.msg,
//         icon: 'danger',
//         confirmButtonText: 'OK',
//       })
//     }


//   }

//   // pgupigateway

//   const pgupigateway = () => {
//     setProcess(true)
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     }
//     axios
//       .post(
//         baseUrl + `/pg-upigateway?amount=${global.toFixed(2)}`,
//         {
//           amount: global,
//         },
//         { headers },
//       )
//       .then((res) => {
//         console.log(res.data.data.result, "sdsd")
//         if (res.data.data.result) {
//           // console.log(res.data.data.data.payment_url)
//           // console.log(res.data.data.data.order_id)
//           // let order_id = res.data.txnID
//           // let order_token = res.data.data.data.order_id
//           //setProcess(false);
//           window.open(res.data.data.result.payment_url)
//           setTimeout(() => {
//             // checkupideposit(order_id, order_token)
//             setProcess(false)
//           }, 60000)
//         } else {
//           setProcess(false)
//           Swal.fire({
//             title: res.data.data.msg,
//             icon: 'danger',
//             confirmButtonText: 'OK',
//           })
//         }
//       })
//       .catch((e) => {
//         alert(e)
//       })
//   }

//   // upigateway3
//   const upigateway03 = async () => {

//     setProcess(true)
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     }

//     const respone = await apiRequest(`wskpay/payin?amount=${global.toFixed(2)}`, "POST", { amount: global }, headers)


//     // .then((res) => {
//     if (respone.data.data.status) {
//       // console.log(res.data.data.data.payment_url)
//       // console.log(res.data.data.data.order_id)
//       let order_id = respone.data.txnID
//       let order_token = respone.data.data.data.order_id
//       //setProcess(false);
//       window.open(respone.data.data.data.payment_url)
//       setTimeout(() => {
//         checkupideposit(order_id, order_token)
//         setProcess(false)
//       }, 60000)
//     } else {
//       setProcess(false)
//       Swal.fire({
//         title: respone.data.data.msg,
//         icon: 'danger',
//         confirmButtonText: 'OK',
//       })
//     }


//   }

//   // PHONEPAY GETWAY API

//   const fetchPaymentUrl = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${access_token}`,
//     }
//     try {
//       setIsLoading(true);

//       // const response = await fetch(
//       //   baseUrl + `phonpay-request?amount=${global}`,
//       //   {
//       //     headers: {
//       //       "Content-Type": "application/json",
//       //       Authorization: `Bearer ${access_token}`,
//       //     },
//       //   }
//       // );
//       const respone = await apiRequest(`phonpay-request?amount=${global}`, "GET", null, headers)

//       // const data = await response.json();
//       if (respone) {
//         setIsLoading(false);

//         window.location.href = respone.data.instrumentResponse.redirectInfo.url;
//       }
//     }
//     catch (error) {
//       console.error("Error fetching payment URL:", error);
//       setIsLoading(false);
//     }
//   };
//   // AIRPAY
//   const airpay = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${access_token}`,
//     }
//     try {
//       setIsLoading(true);

//       // const response = await fetch(
//       //   baseUrl + `airpay-request?amount=${global}`,
//       //   {
//       //     headers: {
//       //       "Content-Type": "application/json",
//       //       Authorization: `Bearer ${access_token}`,
//       //     },
//       //   }
//       // );
//       const respone = await apiRequest(`airpay-request?amount=${global}`, "GET", null, headers)

//       // const data = await response.json();
//       if (respone) {
//         setIsLoading(false);

//         window.location.href = respone.data.instrumentResponse.redirectInfo.url;
//       }
//     } catch (error) {
//       console.error("Error fetching payment URL:", error);
//       setIsLoading(false);
//     }
//   };
//   // HOADA PAY GETWAY API
//   const Hoada = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${access_token}`,
//     }
//     try {
//       setIsLoading(true);

//       // const response = await fetch(
//       //   baseUrl + `haodapay-request-payin?amount=${global}`,
//       //   {
//       //     headers: {
//       //       "Content-Type": "application/json",
//       //       Authorization: `Bearer ${access_token}`,
//       //     },
//       //   }
//       // );

//       const respone = await apiRequest(`haodapay-request-payin?amount=${global}`, "GET", null, headers)

//       // const data = await response.json();
//       if (respone) {
//         setTimeout(() => {
//           setIsLoading(false);
//         }, 5000);

//         const isMobile = window.innerWidth < 768;

//         if (isMobile) {
//           //  window.location.href = data.data.data.intent_link;
//           window.location.href = respone.data.data.payment_link;
//         } else {
//           window.location.href = respone.data.data.payment_link;
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching payment URL:", error);
//       setIsLoading(false);
//     }
//   };

//   // MYPAY GETWAY API
//   // const myPay = () => {
//   //   setProcess(true);
//   //   const access_token = localStorage.getItem("token");
//   //   const headers = {
//   //     Authorization: `Bearer ${access_token}`,
//   //   };
//   //   axios
//   //     .post(
//   //       baseUrl + `mypay/payin`,
//   //       {
//   //         amount: global,
//   //       },
//   //       { headers }
//   //     )
//   //     .then((res) => {
//   //       // console.log(res.data?.data?.qrstring, "res");
//   //       setProcess(false);
//   //       if (res.data.status == false) {
//   //         Swal.fire({
//   //           title: res.data.msg,
//   //           icon: "danger",
//   //           confirmButtonText: "OK",
//   //         });
//   //       } else if (res.data) {
//   //         let order_id = res.data.txnID;
//   //         let order_token = res.data.clientrefid;
//   //         //setProcess(false);
//   //         window.open(`${res.data?.data?.qrstring}&am=${global}`);
//   //         setTimeout(() => {
//   //           checkupideposit(order_id, order_token);
//   //           setProcess(false);
//   //         }, 30000);
//   //       } else {
//   //         setProcess(false);
//   //         Swal.fire({
//   //           title: res.data.status,
//   //           icon: "danger",
//   //           confirmButtonText: "OK",
//   //         });
//   //       }
//   //     })
//   //     .catch((e) => {
//   //       setProcess(false);
//   //       console.log(e, "error");

//   //       if (e.response.status == 400 || e.response.status == 429) {
//   //         Swal.fire({
//   //           title: e.response.msg,
//   //           icon: "warning",
//   //           confirmButtonText: "OK",
//   //         });
//   //       } else {
//   //         Swal.fire({
//   //           title: "error!! Please refresh and connect to admin",
//   //           icon: "warning",
//   //           confirmButtonText: "OK",
//   //         });
//   //       }
//   //       alert(e);
//   //     });
//   // };
//   const myPay = async () => {
//     setProcess(true);
//     const access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };
//     const respone = await apiRequest(`kvmpay/payin`, "POST", { amount: global }, headers)

//     // .then((res) => {
//     console.log(respone, "res");
//     setProcess(false);
//     if (respone.data.status == false) {
//       Swal.fire({
//         title: respone.data.msg,
//         icon: "danger",
//         confirmButtonText: "OK",
//       });
//     } else if (respone.data) {
//       let order_id = respone.data.txnID;
//       let order_token = respone.data.paymentReferenceId;
//       //setProcess(false);
//       window.open(`${respone?.data?.qrcodE_STRING}&am=${global}`);
//       setTimeout(() => {
//         checkupideposit(order_id, order_token);
//         setProcess(false);
//       }, 30000);
//     } else {
//       setProcess(false);
//       Swal.fire({
//         title: respone.data.status,
//         icon: "danger",
//         confirmButtonText: "OK",
//       });
//     }
//     // })
//     // .catch((e) => {
//     //   setProcess(false);
//     //   console.log(e, "error");

//     //   if (e.response.status == 400 || e.response.status == 429) {
//     //     Swal.fire({
//     //       title: e.response.msg,
//     //       icon: "warning",
//     //       confirmButtonText: "OK",
//     //     });
//     //   } else {
//     //     Swal.fire({
//     //       title: "error!! Please refresh and connect to admin",
//     //       icon: "warning",
//     //       confirmButtonText: "OK",
//     //     });
//     //   }
//     //   alert(e);
//     // });
//   };

//   const checkupideposit = async (order_id, order_token) => {
//     const access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };

//     const respone = await apiRequest(`depositupipay/response`, "POST", { order_id, order_token }, headers)

//     // .then((res) => {
//     const icon = respone.data.status == "PAID" ? "success" : "danger";
//     const title =
//       respone.data.status == "PAID"
//         ? "Deposit submited successfully"
//         : "Transaction Failed";
//     history.push("/");
//     setTimeout(() => {
//       Swal.fire({
//         title: title,
//         icon: icon,
//         confirmButtonText: "OK",
//       });
//     }, 1000);
//     // })
//     // .catch((e) => {
//     //   if (e.response.status == 401) {
//     //     localStorage.removeItem("token");
//     //     localStorage.removeItem("token");
//     //     window.location.reload();
//     //   }
//     // });
//   };

//   //use for cashfree gatway
//   const deposit = async (channel, method, upiMethod) => {
//     setProcess(true);
//     const access_token = localStorage.getItem("token");


//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };

//     const alldata = {
//       amount: global,
//       channel: channel,
//       payment_method: method,
//       provider: walletOption,
//       bankCode: bankCode,
//     }

//     try {
//       const respone = await apiRequest(`user/deposite`, "POST", alldata, headers)

//       if (respone.data.data.payment_method == "app") {
//         window.location.href = respone.data.data.data.url;
//         checkInterval = setInterval(
//           (ID) => {
//             checkout(ID);
//           },
//           10000,
//           respone.data.txnID
//         );
//       } else if (
//         respone.data.data.channel == "link" &&
//         respone.data.data.payment_method == "upi"
//       ) {
//         checkInterval = setInterval(
//           (ID) => {
//             checkout(ID);
//           },
//           10000,
//           respone.data.txnID
//         );
//         window.location.href = respone.data.data.data.payload[upiMethod];
//       } else if (
//         respone.data.data.channel == "qrcode" &&
//         respone.data.data.payment_method == "upi"
//       ) {
//         setQrCode(respone.data.data.data.payload.qrcode);
//         setProcess(false);
//         setNext(3);
//         checkInterval = setInterval(
//           (ID) => {
//             checkout(ID);
//           },
//           10000,
//           respone.data.txnID
//         );
//       }
//     } catch (e) {
//       // alert(e);
//     }
//   };

//   const checkout = async (paymentID) => {
//     socket.emit("getprofile");

//     const access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };

//     try {
//       const respone = await apiRequest(`checkout/deposite/txn`, "POST", { txnID: paymentID }, headers)
//       if (respone.data.txnStatus == "PAID") {
//         walletUpdate();
//         clearInterval(checkInterval);
//         Swal.fire({
//           title: respone.data.msg,
//           icon: "success",
//           confirmButtonText: "OK",
//         });

//         setProcess(false);
//         setNext(1);
//         history.push("/");
//       } else if (respone.data.txnStatus == "FAILED") {
//         walletUpdate();
//         clearInterval(checkInterval);
//         Swal.fire({
//           title: respone.data.msg,
//           icon: "error",
//           confirmButtonText: "OK",
//         });

//         setProcess(false);
//         setNext(1);
//       }
//     } catch (e) {
//       // console.log(e);
//     }
//   };

//   const meeApi = async () => {
//     let access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };

//     try {
//       const respone = await apiRequest("me", "GET", null, headers)

//       setUserAllData(respone.data);
//       setAccount_mail_id(respone.data.Email);
//       setAccount_name(respone.data.holder_name);
//       setAccountPhone(respone.data.Phone);
//     } catch (e) {
//       // if (e.response.status == 401) {
//       //     localStorage.removeItem("token");
//       //     localStorage.removeItem("token");
//       //     window.location.reload();
//       //     history.push("/login");
//       //   }
//     }

//     try {
//       const res = await apiRequest(`website/setting`, "GET", null,)

//       console.log(res, "site");
//       setCashFreeActive(res.data.isCashFreeActive);
//       setRazorPayActive(res.data.isRazorPayActive);
//       setDecentroActive(res.data.isDecentroActive);
//       setPineLabActive(res.data.isPineLabActive);
//       setIsPhonePayActive(res.data.isPhonePayActive);
//       setIsAirPayActive(res.data.isAirPayActive);
//       setIsMyPayActive(res.data.isMyPayActive);
//       // setIsKvmPayActive(res.data.isKvmPayActive);
//       // setUpiGateway(res.data.isUpiGateway);
//       setHoadaPaypayInActive(res.data.isHaodaPayPayInActive);
//     } catch (e) {
//       //   setCashFreeActive(false);
//       //   setRazorPayActive(false);
//       //   setDecentroActive(false);
//       //   setPineLabActive(false);
//       //   setIsPhonePayActive(false);
//       //   setIsAirPayActive(false);
//       //   setIsMyPayActive(false);
//       //   setIsKvmPayActive(false);
//       //   setUpiGateway(false);
//     }

//     if (
//       /Android|webOS|iPhone|iPad|iPod|#fffBerry|IEMobile|Opera Mini/i.test(
//         navigator.userAgent
//       )
//     ) {
//       setMobile(true);
//     }
//   }
//   useEffect(() => {
//     meeApi()
//   }, []);

//   // QR CODE IMAGES DOWNLOAD ---------------------------------------------------

//   const handleImageDownload = (item) => {
//     const link = document.createElement("a");
//     link.href = item;
//     link.download = "QR-Code.png"; // You can specify the downloaded file name here
//     link.click();
//   };
//   // clear Image
//   const clearImage = (e) => {
//     setScrnshot1(null);
//     setScrnshot(null);
//   };
//   // MANUAL PAYMENTS METHODS API

//   const handleChange = (e) => {
//     setScrnshot1(URL.createObjectURL(e.target.files[0]));
//     const image = e.target.files[0];
//     if (image && image.size / 1000 > 300) {
//       console.log(" compression");
//       new Compressor(image, {
//         quality: 0.6,
//         success(compressedResult) {
//           if (compressedResult) {
//             setScrnshot(compressedResult);
//           } else {
//             setScrnshot(image);
//           }
//         },
//       });
//     } else {
//       setScrnshot(e.target.files[0]);
//     }
//   };

//   const ManualPayment = async () => {
//     const access_token = localStorage.getItem("token");
//     var myHeaders = new Headers();
//     myHeaders.append("Authorization", `Bearer ${access_token}`);

//     try {
//       const result = await apiRequest("gatewaysettings/data", "GET", null, myHeaders)
//       console.log(result);
//       setManualData(result.data);
//       setPaynow1Url(result?.data?.paynow1Url);
//       setPayOneImage(result?.data?.isPayOneImage);
//       setPayTwoImage(result?.data?.isPayTwoImage);
//       setPayThreeImage(result?.data?.isPayThreeImage);
//       setPayFourImage(result?.data?.isPayFourImage);
//       setPayFiveImage(result?.data?.isPayFiveImage);
//       setIsMyPayActive(result?.data?.isMypayInActive)
//       setPayinOne(result?.data?.payinOne)
//       setPayinTwo(result?.data?.payinTwo)
//       setUpiGateway(result?.data?.isUpiGateway)
//       setUpiGateway02(result?.data?.isUpiGateway02)
//       setUpiGateway03(result?.data?.isUpiGateway03)
//       setPGGateway(result?.data?.isPgUpiGateway);
//     } catch (error) {
//       // console.log("error", error);
//     }
//   };


//   useEffect(() => {
//     ManualPayment.apply();
//   }, []);

//   // getImage URl

//   const [ImageUrl, setImageUrl] = useState("");
//   const [PaymentLink, setPaymentLink] = useState("");

//   const getImageUrl = (image, url) => {

//     setImageUrl(image);
//     setPaymentLink(url);
//   };

//   // code link payment

//   const copyCode = (e) => {
//     navigator.clipboard.writeText(PayNow1Url);

//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Link Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };
//   const copyCode1 = (e) => {
//     navigator.clipboard.writeText(manualData?.acNo);

//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Account Number Copy",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };
//   const copyCode2 = (e) => {
//     navigator.clipboard.writeText(manualData?.acName);

//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Name Copy",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };
//   const copyCode3 = (e) => {
//     navigator.clipboard.writeText(manualData?.ifsccode);

//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "IFSC Code Copy",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };


//   // kvm pay

//   const payinnn = async () => {
//     setProcess(true);
//     const access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };


//     const res = await apiRequest('zap-upigateway', "POST", { amount: global }, headers)
//     setProcess(false);
//     if (res.data.status == false) {
//       setProcess(false);
//       Swal.fire({
//         title: res.data.msg,
//         icon: "danger",
//         confirmButtonText: "OK",
//       });
//     } else if (res.data) {
//       setProcess(false);
//       let order_id = res.data.txnID;
//       let order_token = res.data.paymentReferenceId;
//       //setProcess(false);

//       if (res.data) {
//         console.log(res.data)
//         setProcess(false);
//         window.open(res.data?.data?.payment_url, "_blank");
//       }
//     } else {
//       setProcess(false);
//       Swal.fire({
//         title: res.data.status,
//         icon: "danger",
//         confirmButtonText: "OK",
//       });
//     }

//   };

//   const paymy = async () => {
//     setProcess(true);
//     const access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };


//     const res = await apiRequest('camlenio/payin01', "POST", { amount: global }, headers)
//     setProcess(false);
//     if (res.data.status == false) {
//       setProcess(false);
//       Swal.fire({
//         title: res.data.msg,
//         icon: "danger",
//         confirmButtonText: "OK",
//       });
//     } else if (res.data) {
//       setProcess(false);
//       let order_id = res.data.txnID;
//       let order_token = res.data.paymentReferenceId;
//       //setProcess(false);

//       if (res.data?.payload?.web) {
//         setProcess(false);
//         window.open(res.data?.payload?.web, "_blank");
//       }
//     } else {
//       setProcess(false);
//       Swal.fire({
//         title: res.data.status,
//         icon: "danger",
//         confirmButtonText: "OK",
//       });
//     }

//   };

//   const ManualPayments = async () => {
//     setIsloading1(true);
//     var formdata = new FormData();
//     formdata.append("Transaction_Screenshot", scrnshot);
//     formdata.append("amount", global);
//     formdata.append("referenceId", utr);

//     const access_token = localStorage.getItem("token");
//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };

//     // fetch(baseUrl + "manual/deposit/txn", requestOptions)

//     const result = await apiRequest("manual/deposit/txn", "POST", formdata, headers)
//     // .then((response) => response.json())
//     // .then((result) => {  
//     setIsloading1(false);

//     if (result?.data?.status === "Pending") {
//       Swal.fire({
//         title: result?.data?.message,
//         icon: "success",
//         confirmButtonText: "OK",
//       });
//     } else {
//       Swal.fire({
//         title: result?.data?.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//     history.push("/");
//     handleClose_won();
//     // })

//     // .catch((error) => console.log("error", error));
//   };


// const handleIMBGateway = async () => {
//   try {
//     const access_token = localStorage.getItem("token");

//     const finalAmount = amount || global;

//     // ✅ validation
//     if (!finalAmount || finalAmount <= 0) {
//       return Swal.fire({
//         title: "Enter valid amount",
//         icon: "warning",
//       });
//     }

//     const headers = {
//       Authorization: `Bearer ${access_token}`,
//     };

//     // ✅ apiRequest use (GET)
//     const res = await apiRequest(
//       `imb-request?amount=${finalAmount}`,
//       "GET",
//       null,
//       headers
//     );

//     if (res?.data?.status === true && res?.data?.payment_url) {
//       Swal.fire({
//         title: "Redirecting...",
//         icon: "info",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       setTimeout(() => {
//         window.location.href = res.data.payment_url;
//       }, 1200);
//     } else {
//       Swal.fire({
//         title: res?.data?.msg || "Payment Failed",
//         icon: "error",
//       });
//     }
//   } catch (err) {
//     Swal.fire({
//       title: "Connection Failed",
//       text: err?.message || "Try again",
//       icon: "error",
//     });
//   }
// };

//   // language 
//   const translations = {
//     hi: {
//       addMoney: 'पैसे जोड़ने के लिए राशि चुनें |',
//       money: 'राशि डालें  ',
//       next: 'आगे बड़े ',
//       addAmount: 'राशि जोड़ी जानी है ',
//       referPerson: 'रेफ़रल | ',
//     },
//     en: {
//       addMoney: 'Choose Amount To Add',
//       money: 'Enter Amount',
//       next: 'Next',
//       addAmount: 'Amount to be added',
//       referPerson: 'Referral',
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   // change theme 
//   const theme = localStorage.getItem('theme')

//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
//     color: theme === 'light' ? '#000' : '#fff',
//     // padding: '20px',
//     // margin: '20px',
//   };



//   return (
//     <>
//       <Header user={userAllData} />

//       <div className="leftContainer position-relative mb_space" style={{ ...styles, height: "112vh" }}>

//         <div className=" mt-5  Orher_page_main_section">



//           {Boolean(!process1) && (
//             <div>
//               {Boolean(next == 1) && (
//                 <div className="profile_box">
//                   <div className="money_deposit_card">

//                     <h2 className="card_heading">{translations[language].addMoney} 💰</h2>

//                     {/* --- 1. AMOUNT INPUT SECTION --- */}
//                     <div className="amount_input_group">
//                       <label className="input_label">{translations[language].money}</label>

//                       <div className="input_wrapper">
//                         <span className="rupee_icon">
//                           <img src="/rupee.png" alt="Rupee" className="img-fluid" />
//                         </span>

//                         <input
//                           className="deposit_input"
//                           type="tel"
//                           id="amountInput"
//                           placeholder="Enter amount (Min 10, Max 50000)"
//                           value={global}
//                           // Inline Validation Logic (Kept as is)
//                           onChange={(e) => {
//                             e.target.value > 0
//                               ? e.target.value <= 50000
//                                 ? setGlobal(parseInt(e.target.value))
//                                 : setGlobal(50000)
//                               : e.target.value < 0
//                                 ? setGlobal(10)
//                                 : setGlobal(0);
//                           }}
//                         />
//                       </div>

//                       {/* Optional Hint (Can be uncommented if minLimit/maxLimit are available) */}
//                       {/* <p className="limit_hint">Min: {minLimit}, Max: {maxLimit}</p> */}
//                     </div>

//                     {/* --- 2. QUICK ADD BUTTONS --- */}
//                     <div className="quick_add_buttons">
//                       <button
//                         className="add_btn glow_1"
//                         onClick={() => { setGlobal(100); }}
//                       >
//                         <img src="/Coin without Glow.gif" alt="Coin" />
//                         100
//                       </button>
//                       <button
//                         className="add_btn glow_2"
//                         onClick={() => { setGlobal(250); }}
//                       >
//                         <img src="/Coin without Glow.gif" alt="Coin" />
//                         250
//                       </button>
//                       <button
//                         className="add_btn glow_3"
//                         onClick={() => { setGlobal(500); }}
//                       >
//                         <img src="/Coin without Glow.gif" alt="Coin" />
//                         500
//                       </button>
//                       <button
//                         className="add_btn glow_4"
//                         onClick={() => { setGlobal(2000); }}
//                       >
//                         <img src="/Coin without Glow.gif" alt="Coin" />
//                         2000
//                       </button>
//                     </div>

//                     {/* --- 3. NEXT/STATUS BUTTON --- */}
//                     <div className="action_button_container">
//                       {addCaseSetting.isDeposit ? (
//                         <button
//                           type="button"
//                           id="addcase"
//                           className="next_button neon_border_btn"
//                           onClick={handleNext}
//                         >
//                           {translations[language].next} <BsArrowRight className="icons" />
//                         </button>
//                       ) : (
//                         <p className="deposit_closed_message" id="depositClose">
//                           Deposit services Close for some time
//                         </p>
//                       )}
//                     </div>

//                   </div>
//                 </div>
//               )}

//               {Boolean(next == 2) && (
//                 <div className="">
//                   <>
//                     <div className="pb-3">
//                       <div className={`${css.games_section}`}>
//                         <div className="d-flex position-relative align-items-center justify-content-between">
//                           <div className="add_cash_small_haedings">
//                             {translations[language].addAmount}
//                             <span className="ml-1">₹</span>

//                             <b>{global}</b>
//                           </div>
//                           <button
//                             type="button"
//                             onClick={() => setNext(1)}
//                             className="samll_btn text-dark"
//                           >
//                             Edit
//                           </button>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="mt-3">
//                       <div className="profile_headings">
//                         Pay Through QR CODE
//                       </div>

//                       {/* PHONE pay  */}
//                       {Boolean(isPhonePayActive) && (
//                         <div
//                           onClick={() => fetchPaymentUrl()}
//                           className="add-fund-box mt-3"
//                           style={{ paddingTop: "0px", height: "60px" }}
//                         >
//                           {isLoading ? (
//                             <div
//                               className="loaderReturn"
//                               style={{ zIndex: "99" }}
//                             >
//                               <img
//                                 src={"/images/LandingPage_img/loaderred.gif"}
//                                 style={{ width: "100%" }}
//                               />
//                             </div>
//                           ) : (
//                             <div
//                               className="d-flex align-items-center"
//                               style={{
//                                 backgroundColor: "#fafafa",
//                                 border: "1px solid #e0e0e0",
//                                 borderRadius: "7px",
//                               }}
//                             >
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   height: "60px",
//                                   display: "flex",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <img
//                                   width="40px"
//                                   src="/UPI.png"
//                                   alt=""
//                                   style={{
//                                     marginLeft: "7px",
//                                     paddingBottom: "10px",
//                                     paddingLeft: "3px",
//                                     paddingTop: "5px",
//                                   }}
//                                 />
//                               </div>
//                               <div className="d-flex justify-content-center flex-column ml-4">
//                                 <div className="jss30">
//                                   <strong>Pay Now 1</strong>
//                                 </div>
//                                 <div className="jss31"></div>
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       )}
//                       {/* upigateway */}
//                       {global >= manualData?.upiGatewayMin && Boolean(isUpiGateway) && global <= manualData?.upiGatewayMax ? (
//                         <div
//                           onClick={() => handleIMBGateway()}
//                           className="add-fund-box mt-3"
//                           style={{ paddingTop: "0px", height: "60px" }}
//                         >
//                           {isLoading ? (
//                             <div
//                               className="loaderReturn"
//                               style={{ zIndex: "99" }}
//                             >
//                               <img
//                                 src={"/images/LandingPage_img/loaderred.gif"}
//                                 style={{ width: "100%" }}
//                               />
//                             </div>
//                           ) : (
//                             <div
//                               className="d-flex align-items-center"
//                               style={{
//                                 backgroundColor: "#fafafa",
//                                 border: "1px solid #e0e0e0",
//                                 borderRadius: "7px",
//                               }}
//                             >
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   height: "60px",
//                                   display: "flex",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <img
//                                   width="40px"
//                                   src="/UPI.png"
//                                   alt=""
//                                   style={{
//                                     marginLeft: "7px",
//                                     paddingBottom: "10px",
//                                     paddingLeft: "3px",
//                                     paddingTop: "5px",
//                                   }}
//                                 />
//                               </div>
//                               <div className="d-flex justify-content-center flex-column ml-4">
//                                 <div className="jss30">
//                                   <strong style={{ color: "black" }}>Pay Qr Code  </strong>
//                                 </div>
//                                 <div className="jss31"></div>
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       ) : null}

//                       {/* upigateway */}
//                       {global >= manualData?.upiGatewayMin2 && Boolean(isUpiGateway02) && global <= manualData?.upiGatewayMax2 ? (
//                         <div
//                           onClick={() => upigateway02()}
//                           className="add-fund-box mt-3"
//                           style={{ paddingTop: "0px", height: "60px" }}
//                         >
//                           {isLoading ? (
//                             <div
//                               className="loaderReturn"
//                               style={{ zIndex: "99" }}
//                             >
//                               <img
//                                 src={"/images/LandingPage_img/loaderred.gif"}
//                                 style={{ width: "100%" }}
//                               />
//                             </div>
//                           ) : (
//                             <div
//                               className="d-flex align-items-center"
//                               style={{
//                                 backgroundColor: "#fafafa",
//                                 border: "1px solid #e0e0e0",
//                                 borderRadius: "7px",
//                               }}
//                             >
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   height: "60px",
//                                   display: "flex",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <img
//                                   width="40px"
//                                   src="/UPI.png"
//                                   alt=""
//                                   style={{
//                                     marginLeft: "7px",
//                                     paddingBottom: "10px",
//                                     paddingLeft: "3px",
//                                     paddingTop: "5px",
//                                   }}
//                                 />
//                               </div>
//                               <div className="d-flex justify-content-center flex-column ml-4">
//                                 <div className="jss30">
//                                   <strong style={{ color: "black" }}>Pay Qr Code 2</strong>
//                                 </div>
//                                 <div className="jss31"></div>
//                               </div>
//                             </div>
//                           )}

//                         </div>


//                       ) : null}


//                       {global >= manualData?.upiGatewayMin3 && Boolean(isUpiGateway03) && global <= manualData?.upiGatewayMax3 ? (
//                         <div
//                           onClick={() => pgupigateway()}
//                           className="add-fund-box mt-3"
//                           style={{ paddingTop: "0px", height: "60px" }}
//                         >
//                           {isLoading ? (
//                             <div
//                               className="loaderReturn"
//                               style={{ zIndex: "99" }}
//                             >
//                               <img
//                                 src={"/images/LandingPage_img/loaderred.gif"}
//                                 style={{ width: "100%" }}
//                               />
//                             </div>
//                           ) : (
//                             <div
//                               className="d-flex align-items-center"
//                               style={{
//                                 backgroundColor: "#fafafa",
//                                 border: "1px solid #e0e0e0",
//                                 borderRadius: "7px",
//                               }}
//                             >
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   height: "60px",
//                                   display: "flex",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <img
//                                   width="40px"
//                                   src="/UPI.png"
//                                   alt=""
//                                   style={{
//                                     marginLeft: "7px",
//                                     paddingBottom: "10px",
//                                     paddingLeft: "3px",
//                                     paddingTop: "5px",
//                                   }}
//                                 />
//                               </div>
//                               <div className="d-flex justify-content-center flex-column ml-4">
//                                 <div className="jss30">
//                                   <strong style={{ color: "black" }}>Pay Qr Code 3</strong>
//                                 </div>
//                                 <div className="jss31"></div>
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       ) : null}

//                       {/*Air pay  */}
//                       {global >= manualData?.payinMin && Boolean(payinOne) && global <= manualData?.payinMax ? (
//                         <div
//                           onClick={() => payinnn()}
//                           className="add-fund-box mt-3"
//                           style={{ paddingTop: "0px", height: "60px" }}
//                         >
//                           {isLoading ? (
//                             <div className="loaderReturn" style={{ zIndex: "99" }}>
//                               <img
//                                 src="/images/LandingPage_img/loaderred.gif"
//                                 style={{ width: "100%" }}
//                               />
//                             </div>
//                           ) : (
//                             <div
//                               className="d-flex align-items-center"
//                               style={{
//                                 backgroundColor: "#fafafa",
//                                 border: "1px solid #e0e0e0",
//                                 borderRadius: "7px",
//                               }}
//                             >
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   height: "60px",
//                                   display: "flex",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <img
//                                   width="40px"
//                                   src="/UPI.png"
//                                   alt="UPI Icon"
//                                   style={{
//                                     marginLeft: "7px",
//                                     paddingBottom: "10px",
//                                     paddingLeft: "3px",
//                                     paddingTop: "5px",
//                                   }}
//                                 />
//                               </div>
//                               <div className="d-flex justify-content-center flex-column ml-4">
//                                 <div className="jss30">
//                                   <strong style={{ color: "black" }}>Pay Now</strong>
//                                 </div>
//                                 <div className="jss31"></div>
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       ) : null}
//                       <div>

//                       </div>

//                       {/*Air paymy  */}
//                       {global >= manualData?.payinMin && Boolean(payinTwo) && global <= manualData?.payinMax ? (
//                         <div
//                           onClick={() => paymy()}
//                           className="add-fund-box mt-3"
//                           style={{ paddingTop: "0px", height: "60px" }}
//                         >
//                           {isLoading ? (
//                             <div className="loaderReturn" style={{ zIndex: "99" }}>
//                               <img
//                                 src="/images/LandingPage_img/loaderred.gif"
//                                 style={{ width: "100%" }}
//                               />
//                             </div>
//                           ) : (
//                             <div
//                               className="d-flex align-items-center"
//                               style={{
//                                 backgroundColor: "#fafafa",
//                                 border: "1px solid #e0e0e0",
//                                 borderRadius: "7px",
//                               }}
//                             >
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   height: "60px",
//                                   display: "flex",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <img
//                                   width="40px"
//                                   src="/UPI.png"
//                                   alt="UPI Icon"
//                                   style={{
//                                     marginLeft: "7px",
//                                     paddingBottom: "10px",
//                                     paddingLeft: "3px",
//                                     paddingTop: "5px",
//                                   }}
//                                 />
//                               </div>
//                               <div className="d-flex justify-content-center flex-column ml-4">
//                                 <div className="jss30">
//                                   <strong style={{ color: "black" }}>Pay Now 2</strong>
//                                 </div>
//                                 <div className="jss31"></div>
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       ) : null}


//                       {/* pay account  */}
//                       {manualData?.isAccountActive && global >= manualData?.upiMin && global <= manualData?.upiMax ? (
//                         <div
//                           onClick={() => {
//                             setNext(4);
//                           }}
//                           // onClick={() => fetchPaymentUrl()}
//                           className="add-fund-box mt-3"
//                           style={{ paddingTop: "0px", height: "60px", cursor: "pointer" }}
//                         >
//                           {isLoading ? (
//                             <div
//                               className="loaderReturn"
//                               style={{ zIndex: "99" }}
//                             >
//                               <img
//                                 src={"/images/LandingPage_img/loaderred.gif"}
//                                 style={{ width: "100%" }}
//                               />
//                             </div>
//                           ) : (
//                             <div
//                               className="d-flex align-items-center"
//                               style={{
//                                 backgroundColor: "#fafafa",
//                                 border: "1px solid #e0e0e0",
//                                 borderRadius: "7px",
//                               }}
//                             >
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   height: "60px",
//                                   display: "flex",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <img
//                                   width="40px"
//                                   src="/images/Bank.png"
//                                   alt=""
//                                   style={{
//                                     marginLeft: "7px",
//                                     paddingBottom: "10px",
//                                     paddingLeft: "3px",
//                                     paddingTop: "5px",
//                                   }}
//                                 />
//                               </div>
//                               <div className="d-flex justify-content-center flex-column ml-4">
//                                 <div className="jss30">
//                                   <strong style={{ color: "black" }}>PAY WITH ACCOUNT</strong>
//                                 </div>
//                                 <div className="jss31"></div>
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       ) : (
//                         ""
//                       )}
//                       <div className="Qrcode">
//                         {/* Qr code 1 */}

//                         {manualData?.isPayNowOne && global >= manualData?.upiMin && global <= manualData?.upiMax ? (
//                           <div
//                             onClick={() => {
//                               setNext(3);
//                               getImageUrl(PayOneImage, PayNow1Url);
//                             }}
//                             // onClick={() => fetchPaymentUrl()}
//                             className="add-fund-box mt-3"
//                             style={{ paddingTop: "0px", height: "60px", cursor: "pointer" }}
//                           >
//                             {isLoading ? (
//                               <div
//                                 className="loaderReturn"
//                                 style={{ zIndex: "99" }}
//                               >
//                                 <img
//                                   src={"/images/LandingPage_img/loaderred.gif"}
//                                   style={{ width: "100%" }}
//                                 />
//                               </div>
//                             ) : (
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   backgroundColor: "#fafafa",
//                                   border: "1px solid #e0e0e0",
//                                   borderRadius: "7px",
//                                 }}
//                               >
//                                 <div
//                                   className="d-flex align-items-center"
//                                   style={{
//                                     height: "60px",
//                                     display: "flex",
//                                     textAlign: "center",
//                                   }}
//                                 >
//                                   <img
//                                     width="40px"
//                                     src="/UPI.png"
//                                     alt=""
//                                     style={{
//                                       marginLeft: "7px",
//                                       paddingBottom: "10px",
//                                       paddingLeft: "3px",
//                                       paddingTop: "5px",
//                                     }}
//                                   />
//                                 </div>
//                                 <div className="d-flex justify-content-center flex-column ml-4">
//                                   <div className="jss30">
//                                     <strong style={{ color: "black" }}>QR CODE 1</strong>
//                                   </div>
//                                   <div className="jss31"></div>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           ""
//                         )}

//                         {/* Qr code 2 */}
//                         {manualData?.isPayNowTwo ? (
//                           <div
//                             onClick={() => {
//                               setNext(3);
//                               getImageUrl(PayTwoImage, PayNow2Url);
//                             }}
//                             // onClick={() => fetchPaymentUrl()}
//                             className="add-fund-box mt-3"
//                             style={{ paddingTop: "0px", height: "60px" }}
//                           >
//                             {isLoading ? (
//                               <div
//                                 className="loaderReturn"
//                                 style={{ zIndex: "99" }}
//                               >
//                                 <img
//                                   src={"/images/LandingPage_img/loaderred.gif"}
//                                   style={{ width: "100%" }}
//                                 />
//                               </div>
//                             ) : (
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   backgroundColor: "#fafafa",
//                                   border: "1px solid #e0e0e0",
//                                   borderRadius: "7px",
//                                 }}
//                               >
//                                 <div
//                                   className="d-flex align-items-center"
//                                   style={{
//                                     height: "60px",
//                                     display: "flex",
//                                     textAlign: "center",
//                                   }}
//                                 >
//                                   <img
//                                     width="40px"
//                                     src="/UPI.png"
//                                     alt=""
//                                     style={{
//                                       marginLeft: "7px",
//                                       paddingBottom: "10px",
//                                       paddingLeft: "3px",
//                                       paddingTop: "5px",
//                                     }}
//                                   />
//                                 </div>
//                                 <div className="d-flex justify-content-center flex-column ml-4">
//                                   <div className="jss30">
//                                     <strong>QR CODE 2</strong>
//                                   </div>
//                                   <div className="jss31"></div>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           ""
//                         )}

//                         {/* Qr code 3 */}
//                         {manualData?.isPayNowThree ? (
//                           <div
//                             onClick={() => {
//                               setNext(3);
//                               getImageUrl(PayThreeImage, PayNow3Url);
//                             }}
//                             // onClick={() => fetchPaymentUrl()}
//                             className="add-fund-box mt-3"
//                             style={{ paddingTop: "0px", height: "60px" }}
//                           >
//                             {isLoading ? (
//                               <div
//                                 className="loaderReturn"
//                                 style={{ zIndex: "99" }}
//                               >
//                                 <img
//                                   src={"/images/LandingPage_img/loaderred.gif"}
//                                   style={{ width: "100%" }}
//                                 />
//                               </div>
//                             ) : (
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   backgroundColor: "#fafafa",
//                                   border: "1px solid #e0e0e0",
//                                   borderRadius: "7px",
//                                 }}
//                               >
//                                 <div
//                                   className="d-flex align-items-center"
//                                   style={{
//                                     height: "60px",
//                                     display: "flex",
//                                     textAlign: "center",
//                                   }}
//                                 >
//                                   <img
//                                     width="40px"
//                                     src="/UPI.png"
//                                     alt=""
//                                     style={{
//                                       marginLeft: "7px",
//                                       paddingBottom: "10px",
//                                       paddingLeft: "3px",
//                                       paddingTop: "5px",
//                                     }}
//                                   />
//                                 </div>
//                                 <div className="d-flex justify-content-center flex-column ml-4">
//                                   <div className="jss30">
//                                     <strong>QR CODE 3</strong>
//                                   </div>
//                                   <div className="jss31"></div>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           ""
//                         )}

//                         {/* Qr code 4 */}
//                         {manualData?.isPayNowFour ? (
//                           <div
//                             onClick={() => {
//                               setNext(3);
//                               getImageUrl(PayFourImage, PayNow4Url);
//                             }}
//                             // onClick={() => fetchPaymentUrl()}
//                             className="add-fund-box mt-3"
//                             style={{ paddingTop: "0px", height: "60px" }}
//                           >
//                             {isLoading ? (
//                               <div
//                                 className="loaderReturn"
//                                 style={{ zIndex: "99" }}
//                               >
//                                 <img
//                                   src={"/images/LandingPage_img/loaderred.gif"}
//                                   style={{ width: "100%" }}
//                                 />
//                               </div>
//                             ) : (
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   backgroundColor: "#fafafa",
//                                   border: "1px solid #e0e0e0",
//                                   borderRadius: "7px",
//                                 }}
//                               >
//                                 <div
//                                   className="d-flex align-items-center"
//                                   style={{
//                                     height: "60px",
//                                     display: "flex",
//                                     textAlign: "center",
//                                   }}
//                                 >
//                                   <img
//                                     width="40px"
//                                     src="/UPI.png"
//                                     alt=""
//                                     style={{
//                                       marginLeft: "7px",
//                                       paddingBottom: "10px",
//                                       paddingLeft: "3px",
//                                       paddingTop: "5px",
//                                     }}
//                                   />
//                                 </div>
//                                 <div className="d-flex justify-content-center flex-column ml-4">
//                                   <div className="jss30">
//                                     <strong>QR CODE 4</strong>
//                                   </div>
//                                   <div className="jss31"></div>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           ""
//                         )}

//                         {/* Qr code 5 */}
//                         {manualData?.isPayNowFive ? (
//                           <div
//                             onClick={() => {
//                               setNext(3);
//                               getImageUrl(PayFiveImage, PayNow5Url);
//                             }}
//                             className="add-fund-box mt-3"
//                             style={{ paddingTop: "0px", height: "60px" }}
//                           >
//                             {isLoading ? (
//                               <div
//                                 className="loaderReturn"
//                                 style={{ zIndex: "99" }}
//                               >
//                                 <img
//                                   src={"/images/LandingPage_img/loaderred.gif"}
//                                   style={{ width: "100%" }}
//                                 />
//                               </div>
//                             ) : (
//                               <div
//                                 className="d-flex align-items-center"
//                                 style={{
//                                   backgroundColor: "#fafafa",
//                                   border: "1px solid #e0e0e0",
//                                   borderRadius: "7px",
//                                 }}
//                               >
//                                 <div
//                                   className="d-flex align-items-center"
//                                   style={{
//                                     height: "60px",
//                                     display: "flex",
//                                     textAlign: "center",
//                                   }}
//                                 >
//                                   <img
//                                     width="40px"
//                                     src="/UPI.png"
//                                     alt=""
//                                     style={{
//                                       marginLeft: "7px",
//                                       paddingBottom: "10px",
//                                       paddingLeft: "3px",
//                                       paddingTop: "5px",
//                                     }}
//                                   />
//                                 </div>
//                                 <div className="d-flex justify-content-center flex-column ml-4">
//                                   <div className="jss30">
//                                     <strong>QR CODE 5</strong>
//                                   </div>
//                                   <div className="jss31"></div>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         ) : (
//                           ""
//                         )}


//                         {/* whatsapp Payment */}
//                         {global >= manualData?.whatsappRangemin && Boolean(manualData?.whatsappDeposit) && global <= manualData?.whatsappRangemax && (

//                           <>
//                             {/* <div class="alrt_msg_div">
//                               <h5 class="">
//                                 {addCaseSetting?.ludoClassicAutobattleMsg}
//                               </h5>
//                             </div> */}

//                             <div class="text-center mt-1">
//                               <h4>Payment Amount</h4>
//                               <h5 class="text-danger">₹ {global}</h5>
//                               <div class="form-group position-relative">
//                                 <label for="paymentMethod">Payment Method</label>
//                               </div>
//                             </div>
//                             <div class="alrt_msg_div">
//                               <h5 class="" style={{ fontSize: "0.9rem", lineHeight: "25px" }}>
//                                 {addCaseSetting?.whatsappDepositmsg}
//                               </h5>
//                             </div>
//                             <div className="d-whatsaap-page" style={{ textAlign: 'center' }}>
//                               <a class="text-light blink f-flex"> <img src="../down-arrow.png" style={{ width: "20%", marginBottom: "10px" }} /> </a>
//                             </div>

//                             <div className="d-whatsaap-page" style={{ textAlign: 'center' }}>
//                               <a class="btn   btn-success text-light f-flex" href={`https://wa.me/+91${addCaseSetting?.whatsappDepositNo}`}> <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" class="bi bi-whatsapp " viewBox="0 0 16 16">
//                                 <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
//                               </svg> </a>
//                             </div>
//                             {/* <div className="d-flex align-items-center justify-content-center" style={{ margin: "auto", marginTop: "28px" }}>
//                               <button
//                                 className="results_btn results_btn_win mt-2"
//                                 onClick={handleShow_won}
//                               >
//                                 {" "}
//                                 Upload Payment Details
//                               </button>
//                             </div> */}

//                           </>

//                         )}
//                       </div>
//                       {/* {addCaseSetting?.whatsappDepositmsg && (
//                         <div className="max-w-md mx-auto mt-4 p-5 rounded-2xl bg-white/20 backdrop-blur-md shadow-xl border border-white/30 text-gray-900">
//                           <h5 className="text-lg font-bold mb-2 flex items-center gap-2">
//                             <span className="text-blue-600 text-xl">📢</span> Notice
//                           </h5>
//                           <p className="text-sm leading-relaxed">
//                             {addCaseSetting?.whatsappDepositmsg}
//                           </p>
//                         </div>

//                       )} */}

//                     </div>
//                   </>
//                 </div>
//               )}

//               {Boolean(next == 3) && (
//                 <>
//                   {/* Caution Message Card - Unchanged */}

//                   <p class="alrt_msg_div">
//                     कृपया सुनिश्चित करें कि आप **मैन्युअल डिपॉजिट अमाउंट** के बराबर ही भुगतान करें। **UTR नंबर** और **स्क्रीनशॉट** के बिना **कम या ज्यादा** पेमेंट **ऐड नहीं होगा**।
//                   </p>


//                   {/* QR Code Section */}
//                   <div className="payment-qr-section-small"> {/* Changed class name */}
//                     <h4 className="payment-section-title">
//                       💰 Scan and Pay Instantly
//                     </h4>

//                     {/* Simplified QR container, removing extra box structure */}
//                     <div className="qr-image-wrapper">
//                       <img
//                         className="qr-image-style"
//                         src={baseUrl + `/${ImageUrl}`}
//                         alt="Payment QR Code"
//                       />
//                     </div>

//                     {/* Payment Link / VPA (Virtual Payment Address) Section */}
//                     <div className="vpa-link-container">
//                       <div className="vpa-link-wrapper">
//                         <span className="vpa-link-value">{PayNow1Url}</span>
//                         <button className="copy-action-btn" onClick={(e) => copyCode(e)}>Copy</button>
//                       </div>
//                     </div>
//                   </div>


//                   {/* Upload Button Section - Unchanged */}
//                   <div className="upload-action-container">
//                     <button
//                       className="upload-main-btn"
//                       onClick={handleShow_won}
//                     >
//                       ✅ Upload Payment Details
//                     </button>
//                   </div>
//                 </>
//               )}
//               {Boolean(next == 4) && (
//                 <>
//                   <p class="alrt_msg_div">
//                     अगर कोई यूजर मैन्युअल डिपॉजिट अमाउंट जितना पे करता है उतना ही पेमेंट डालकर UTR नंबर और स्क्रीनशॉट सबमिट करें। अगर आप पेमेंट कम या ज्यादा डालते हैं, तो आपका किया हुआ डिपॉजिट ऐड नहीं होगा ।
//                   </p>

//                   {/* Account Details List */}
//                   <div className="account-details-list">
//                     {/* Account Number Item */}
//                     <div className="detail-item">
//                       <span className="detail-label">Account Number</span>
//                       <div className="detail-value-container">
//                         <span className="detail-value primary-value">
//                           {manualData?.acNo || 'N/A'}
//                         </span>
//                         <button className="copy-btn" onClick={(e) => copyCode1(e)}>Copy</button>
//                       </div>
//                     </div>

//                     {/* Beneficiary Name Item */}
//                     <div className="detail-item">
//                       <span className="detail-label">Beneficiary Name</span>
//                       <div className="detail-value-container">
//                         <span className="detail-value primary-value">
//                           {manualData?.acName || 'N/A'}
//                         </span>
//                         <button className="copy-btn" onClick={(e) => copyCode2(e)}>Copy</button>
//                       </div>
//                     </div>

//                     {/* IFSC Code Item */}
//                     <div className="detail-item">
//                       <span className="detail-label">IFSC Code</span>
//                       <div className="detail-value-container">
//                         <span className="detail-value primary-value">
//                           {manualData?.ifsccode || 'N/A'}
//                         </span>
//                         <button className="copy-btn" onClick={(e) => copyCode3(e)}>Copy</button>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Note Section */}
//                   <div className="note-section">
//                     <p>
//                       **NOTE** :- पेमेंट सक्सेस होने के बाद नीचे दिए गए बटन पर क्लिक करके **स्क्रीनशॉट** और **UTR नंबर** डालके सबमिट कर दें।
//                     </p>
//                   </div>

//                   {/* Upload Button */}
//                   <div className="upload-btn-container">
//                     <button
//                       className="upload-btn"
//                       onClick={handleShow_won}
//                     >
//                       📤 Upload Payment Details
//                     </button>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {Boolean(process1) && (
//             <div className="loaderReturn" style={{ zIndex: "99" }}>
//               <img
//                 src={"/images/LandingPage_img/loaderred.gif"}
//                 style={{ width: "100%" }}
//               />
//             </div>
//           )}
//         </div>

//         {/* {next === 2 && addCaseSetting.depositGuide ?
//           <div className="youtube-btn-pos text-center">
//             <a
//               href={addCaseSetting.depositGuide}
//               target="_blank"
//             >
//               <span

//                 className={`${css.gamesSectionHeadline} text-uppercase position-absolute  font-weight-bold `}

//                 style={{

//                   backgroundColor: "#003441",
//                   color: "white",
//                   borderRadius: "4px",
//                   padding: "8px 16px",
//                   fontSize: "12px",
//                   border: "3px solid yellow",
//                   borderRadius: "30px"
//                 }}

//               >
//                 <h5 className="mb-0">पेमेंट add करना सीखे </h5>
//                 Youtube
//                 <img
//                   className="ml-2 blink"
//                   src={"/images/Homepage/youtube.png"}
//                   alt=""
//                   width="15px"
//                 />
//               </span>
//             </a>
//           </div> : ""
//         } */}
//       </div>



//       <section className="win_modal">
//         <Modal
//           show={show_won}
//           onHide={handleClose_won}
//           className="cancel_popup_reason_popup payments_popup"
//           aria-labelledby="contained-modal-title-vcenter"
//           centered
//         >
//           <Modal.Header className="justify-content-center" closeButton>
//             <h3>Payment Details</h3>
//           </Modal.Header>
//           <Modal.Body>
//             <div>

//               <div>
//                 <lable className="commaon_label">AMOUNT</lable>
//                 <input
//                   className="commaon_input_box mb-3"
//                   type="number"
//                   required
//                   value={global}
//                   onChange={(e) => setGlobal(e.target.value)}
//                   placeholder="Enter amount"
//                   readOnly
//                 />
//                 <lable className="commaon_label mt-4">UTR NUMBER</lable>
//                 <input
//                   className="commaon_input_box"
//                   type="text"
//                   required
//                   value={utr}
//                   onChange={(e) => setutr(e.target.value)}
//                   placeholder="Enter UTR Number"
//                 />
//               </div>

//               <div className={`${css1.doc_upload} mt-4 upload_ss_btn bg-white-1 p-0`}>
//                 <input
//                   type="file"
//                   onChange={handleChange}
//                   accept="image/*"
//                   required
//                 />
//                 {!scrnshot && (
//                   <div className="cxy flex-column position-absolute ">

//                     <div
//                       className={`${css1.sideNav_text}  upload_ss_btn_name text-white`}
//                     >
//                       Upload screenshot.
//                     </div>
//                   </div>
//                 )}
//                 {scrnshot && (
//                   <div className={css1.uploaded}>
//                     <img
//                       src="/images/file-icon.png"
//                       width="26px"
//                       alt=""
//                       style={{ marginRight: "20px" }}
//                     />
//                     <div
//                       className="d-flex flex-column"
//                       style={{ width: "80%" }}
//                     >
//                       <div
//                         className={`${css1.name} `}
//                         style={{ color: "#fff" }}
//                       >
//                         {scrnshot.name}
//                       </div>
//                       <div className={css1.size}>
//                         {(scrnshot.size / 1024 / 1024).toFixed(2)} MB
//                       </div>
//                     </div>
//                     <div className="image-block">
//                       <img
//                         src="/images/global-cross.png"
//                         width="10px"
//                         alt=""
//                         onClick={() => {
//                           clearImage();
//                           handleClose_won();
//                         }}
//                       />
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <div style={{ width: "100%", marginTop: "20px" }}>
//                 <img
//                   src={scrnshot1}
//                   style={{ width: "100%" }}
//                   className="screenshot_img"
//                   required
//                 />
//               </div>

//               {/* {fecthStatus == null && fecthStatus == undefined && (
//                 <input
//                   type="submit"
//                   value="Submit"
//                   className="btn btn-danger mt-3 text-white results_btn w-100"
//                   id="post"
//                   // onClick={(e) => {
//                   //   Result(e);
//                   // }}
//                   onClick={ManualPayments}
//                   disabled={!scrnshot}
//                 />
                
//               )} */}



//               {fecthStatus == null && fecthStatus == undefined && (
//                 <>
//                   {isLoading1 ? (
//                     <button className="Login-button cxy" disabled>
//                       <Spinner
//                         as="span"
//                         animation="grow"
//                         size="sm"
//                         role="status"
//                         aria-hidden="true"
//                       />
//                       Loading...
//                     </button>
//                   ) : (
//                     <input
//                       type="submit"
//                       value="SUBMIT"
//                       className="btn btn-primary mt-3 text-white results_btn w-100"
//                       id="post"
//                       onClick={ManualPayments}
//                       disabled={!utr}
//                       style={{ fontSize: "20px !important" }}
//                     />
//                   )}
//                 </>
//               )}
//             </div>

//           </Modal.Body>
//         </Modal>
//       </section>

//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </>
//   );
// };

// export default Addcase;
import axios from "axios";
import React, { useRef, useState, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import css from "../css/Addcase.module.css";
import Compressor from "compressorjs";
import css1 from "../css/Pan.module.css";
import Rightcontainer from "../Components/Rightcontainer";
import "../css/Loader.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/viewGame1.css";
import "../css/layout.css";
import buttonIcon from '../../assets/images/youtube.png';
import Swal from "sweetalert2";
import Header from "../Components/Header";
import socket from "../Components/socket";
import "../css/landing.css";
import Modal from "react-bootstrap/Modal";
import { BsArrowRight, BsQrCodeScan, BsWhatsapp } from "react-icons/bs";
import DownloadLink from "react-download-link";
import Spinner from "react-bootstrap/Spinner";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";

const Addcase = ({ walletUpdate }) => {
  const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const history = useHistory();
  let method = useRef();
  let checkInterval;
  const [userAllData, setUserAllData] = useState();

  const access_token = localStorage.getItem("token");

  const [isLoading1, setIsloading1] = useState(false); 
  const [global, setGlobal] = useState(100);
  const [next, setNext] = useState(1);
  const [process1, setProcess] = useState(false);
  const [isMobile, setMobile] = useState(false);

  const [isCashFreeActive, setCashFreeActive] = useState(true);
  const [isPhonePayActive, setIsPhonePayActive] = useState(false);
  const [isAirPayActive, setIsAirPayActive] = useState(false);
  const [payinOne, setPayinOne] = useState(false);
  const [payinTwo, setPayinTwo] = useState(false);
  const [isUpiGateway, setUpiGateway] = useState(false);
  const [isUpiGateway02, setUpiGateway02] = useState(false);
  const [isUpiGateway03, setUpiGateway03] = useState(false);
  const [isMyPayActive, setIsMyPayActive] = useState(false);
  const [isPineLabActive, setPineLabActive] = useState(false);
  const [isRazorPayActive, setRazorPayActive] = useState(false);
  const [isDecentroActive, setDecentroActive] = useState(false);
  const [isHoadaPaypayInActive, setHoadaPaypayInActive] = useState(false);
  const [ManualPaymentdata, setManualPaymentdata] = useState([]);

  const [manualData, setManualData] = useState([]);
  const [PayOneImage, setPayOneImage] = useState("");
  const [PayTwoImage, setPayTwoImage] = useState("");
  const [PayThreeImage, setPayThreeImage] = useState("");
  const [PayFourImage, setPayFourImage] = useState("");
  const [PayFiveImage, setPayFiveImage] = useState("");

  const [PayNow1Url, setPaynow1Url] = useState("");
  const [PayNow2Url, setPaynow2Url] = useState("");
  const [PayNow3Url, setPaynow3Url] = useState("");
  const [PayNow4Url, setPaynow4Url] = useState("");
  const [PayNow5Url, setPaynow5Url] = useState("");

  const [show_won, setShow_won] = useState(false);
  const handleClose_won = () => setShow_won(false);
  const [scrnshot, setScrnshot] = useState(null);
  const [fecthStatus, setFecthStatus] = useState();
  const [scrnshot1, setScrnshot1] = useState("");
  const handleShow_won = () => setShow_won(true);

  const [qrCode, setQrCode] = useState();
  const [walletOption, setWalletOption] = useState("airtel");
  const [bankCode, setBankCode] = useState(3003);

  const [account_mail_id, setAccount_mail_id] = useState();
  const [account_name, setAccount_name] = useState();
  const [accountPhone, setAccountPhone] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [minLimit, setMinLimit] = useState(null);
  const [maxLimit, setMaxLimit] = useState(null);
  const [amount, setamount] = useState("");
  const [utr, setutr] = useState("");
  const [pgUpiGateway, setPGGateway] = useState(false);

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [hoadaPay, setHoadaPay] = useState(false);

  useEffect(() => {
    setMinLimit(addCaseSetting.depositlimitMin);
    setMaxLimit(addCaseSetting.depositlimitMax);

    if (!addCaseSetting.isDeposit) {
      <script>
        document.getElementById("addcase").style.display = "none";
        document.getElementById("depositClose").style.display = "block";
      </script>
    }
  }, []);

  const handleNext = () => {
    if (global < minLimit || global > maxLimit) {
      Swal.fire({
        title: `Minimum amount should be greater than ${minLimit} and maximum amount should be less than ${maxLimit}`,
        confirmButtonText: "OK",
        content: "custom-swal-content",
        background: '#1a1a2e',
        color: '#fff',
      });
    } else {
      setNext(2);
    }
  };

  function loadRazorpayScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpayPaymentSdk(channel, method, upiMethod, razorpay) {
    const res = await loadRazorpayScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!res) {
      alert("Razorpay SDK failed to load. please check are you online?");
      return;
    }
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    let alldata = {
      amount: global,
      channel: channel,
      payment_method: method,
      provider: walletOption,
      bankCode: bankCode,
      account_name: account_name,
      payment_gatway: razorpay,
    }

    const response = await apiRequest('user/razorpay_order', "POST", alldata, headers)

    if (!response) {
      alert("Server error. please check are you onlin?");
      return;
    }

    let order_id = response.data.txnID;
    let order_token = response.data.orderdata.id;
    const data = response.data.orderdata;
    const options = {
      key: "rzp_live_hmxBSXgEqtBqJq",
      name: "Rk Ludo",
      description: "Skill Based Game Tournament",
      order_id: data.id,
      prefill: {
        name: account_name,
        email: account_mail_id,
        contact: accountPhone,
      },
      handler: async (response) => {
        try {
          const paymentId = response.razorpay_payment_id;
          checkrazorpaydeposit(order_id, order_token, "SUCCESS", paymentId);
        } catch (err) {
          checkrazorpaydeposit(order_id, order_token, "FAILED");
          console.log(err);
        }
      },
      theme: { color: "#686CFD" },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  const checkrazorpaydeposit = async (order_id, order_token, order_status, paymentId) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    let alldeta2 = { order_id, order_token, order_status, paymentId }
    const response = await apiRequest('user/razorpay_order', "POST", alldeta2, headers)

    const icon = response.data.status == "PAID" ? "success" : "danger";
    const title = response.data.status == "PAID" ? "Deposit submited successfully" : "Transaction Failed";
    history.push("/");
    setTimeout(() => {
      Swal.fire({
        title: title,
        icon: icon,
        confirmButtonText: "OK",
      });
    }, 1000);
  };

  const upigateway = async () => {
    setProcess(true)
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }

    const respone = await apiRequest(`user/depositeupi?amount=${global.toFixed(2)}`, "POST", { amount: global }, headers)

    if (respone.data.data.status) {
      let order_id = respone.data.txnID
      let order_token = respone.data.data.data.order_id
      window.open(respone.data.data.data.payment_url)
      setTimeout(() => {
        checkupideposit(order_id, order_token)
        setProcess(false)
      }, 60000)
    } else {
      setProcess(false)
      Swal.fire({ title: respone.data.data.msg, icon: 'danger', confirmButtonText: 'OK' })
    }
  }

  const upigateway02 = async () => {
    setProcess(true)
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }

    const respone = await apiRequest(`user/depositeupi02?amount=${global.toFixed(2)}`, "POST", { amount: global }, headers)

    if (respone.data.data.status) {
      let order_id = respone.data.txnID
      let order_token = respone.data.data.data.order_id
      window.open(respone.data.data.data.payment_url)
      setTimeout(() => {
        checkupideposit(order_id, order_token)
        setProcess(false)
      }, 60000)
    } else {
      setProcess(false)
      Swal.fire({ title: respone.data.data.msg, icon: 'danger', confirmButtonText: 'OK' })
    }
  }

  const pgupigateway = () => {
    setProcess(true)
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }
    axios
      .post(baseUrl + `/pg-upigateway?amount=${global.toFixed(2)}`, { amount: global }, { headers })
      .then((res) => {
        if (res.data.data.result) {
          window.open(res.data.data.result.payment_url)
          setTimeout(() => { setProcess(false) }, 60000)
        } else {
          setProcess(false)
          Swal.fire({ title: res.data.data.msg, icon: 'danger', confirmButtonText: 'OK' })
        }
      })
      .catch((e) => { alert(e) })
  }

  const upigateway03 = async () => {
    setProcess(true)
    const access_token = localStorage.getItem('token')
    const headers = { Authorization: `Bearer ${access_token}` }

    const respone = await apiRequest(`wskpay/payin?amount=${global.toFixed(2)}`, "POST", { amount: global }, headers)

    if (respone.data.data.status) {
      let order_id = respone.data.txnID
      let order_token = respone.data.data.data.order_id
      window.open(respone.data.data.data.payment_url)
      setTimeout(() => {
        checkupideposit(order_id, order_token)
        setProcess(false)
      }, 60000)
    } else {
      setProcess(false)
      Swal.fire({ title: respone.data.data.msg, icon: 'danger', confirmButtonText: 'OK' })
    }
  }

  const fetchPaymentUrl = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    }
    try {
      setIsLoading(true);
      const respone = await apiRequest(`phonpay-request?amount=${global}`, "GET", null, headers)
      if (respone) {
        setIsLoading(false);
        window.location.href = respone.data.instrumentResponse.redirectInfo.url;
      }
    }
    catch (error) {
      console.error("Error fetching payment URL:", error);
      setIsLoading(false);
    }
  };

  const airpay = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    }
    try {
      setIsLoading(true);
      const respone = await apiRequest(`airpay-request?amount=${global}`, "GET", null, headers)
      if (respone) {
        setIsLoading(false);
        window.location.href = respone.data.instrumentResponse.redirectInfo.url;
      }
    } catch (error) {
      console.error("Error fetching payment URL:", error);
      setIsLoading(false);
    }
  };

  const Hoada = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    }
    try {
      setIsLoading(true);
      const respone = await apiRequest(`haodapay-request-payin?amount=${global}`, "GET", null, headers)
      if (respone) {
        setTimeout(() => { setIsLoading(false); }, 5000);
        const isMobile = window.innerWidth < 768;
        if (isMobile) {
          window.location.href = respone.data.data.payment_link;
        } else {
          window.location.href = respone.data.data.payment_link;
        }
      }
    } catch (error) {
      console.error("Error fetching payment URL:", error);
      setIsLoading(false);
    }
  };

  const myPay = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const respone = await apiRequest(`kvmpay/payin`, "POST", { amount: global }, headers)

    setProcess(false);
    if (respone.data.status == false) {
      Swal.fire({ title: respone.data.msg, icon: "danger", confirmButtonText: "OK" });
    } else if (respone.data) {
      let order_id = respone.data.txnID;
      let order_token = respone.data.paymentReferenceId;
      window.open(`${respone?.data?.qrcodE_STRING}&am=${global}`);
      setTimeout(() => {
        checkupideposit(order_id, order_token);
        setProcess(false);
      }, 30000);
    } else {
      setProcess(false);
      Swal.fire({ title: respone.data.status, icon: "danger", confirmButtonText: "OK" });
    }
  };

  const checkupideposit = async (order_id, order_token) => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const respone = await apiRequest(`depositupipay/response`, "POST", { order_id, order_token }, headers)

    const icon = respone.data.status == "PAID" ? "success" : "danger";
    const title = respone.data.status == "PAID" ? "Deposit submited successfully" : "Transaction Failed";
    history.push("/");
    setTimeout(() => {
      Swal.fire({ title: title, icon: icon, confirmButtonText: "OK" });
    }, 1000);
  };

  const deposit = async (channel, method, upiMethod) => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    const alldata = {
      amount: global,
      channel: channel,
      payment_method: method,
      provider: walletOption,
      bankCode: bankCode,
    }

    try {
      const respone = await apiRequest(`user/deposite`, "POST", alldata, headers)

      if (respone.data.data.payment_method == "app") {
        window.location.href = respone.data.data.data.url;
        checkInterval = setInterval((ID) => { checkout(ID); }, 10000, respone.data.txnID);
      } else if (respone.data.data.channel == "link" && respone.data.data.payment_method == "upi") {
        checkInterval = setInterval((ID) => { checkout(ID); }, 10000, respone.data.txnID);
        window.location.href = respone.data.data.data.payload[upiMethod];
      } else if (respone.data.data.channel == "qrcode" && respone.data.data.payment_method == "upi") {
        setQrCode(respone.data.data.data.payload.qrcode);
        setProcess(false);
        setNext(3);
        checkInterval = setInterval((ID) => { checkout(ID); }, 10000, respone.data.txnID);
      }
    } catch (e) {
      // alert(e);
    }
  };

  const checkout = async (paymentID) => {
    socket.emit("getprofile");
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    try {
      const respone = await apiRequest(`checkout/deposite/txn`, "POST", { txnID: paymentID }, headers)
      if (respone.data.txnStatus == "PAID") {
        walletUpdate();
        clearInterval(checkInterval);
        Swal.fire({ title: respone.data.msg, icon: "success", confirmButtonText: "OK" });
        setProcess(false);
        setNext(1);
        history.push("/");
      } else if (respone.data.txnStatus == "FAILED") {
        walletUpdate();
        clearInterval(checkInterval);
        Swal.fire({ title: respone.data.msg, icon: "error", confirmButtonText: "OK" });
        setProcess(false);
        setNext(1);
      }
    } catch (e) {}
  };

  const meeApi = async () => {
    let access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    try {
      const respone = await apiRequest("me", "GET", null, headers)
      setUserAllData(respone.data);
      setAccount_mail_id(respone.data.Email);
      setAccount_name(respone.data.holder_name);
      setAccountPhone(respone.data.Phone);
    } catch (e) {}

    try {
      const res = await apiRequest(`website/setting`, "GET", null,)
      setCashFreeActive(res.data.isCashFreeActive);
      setRazorPayActive(res.data.isRazorPayActive);
      setDecentroActive(res.data.isDecentroActive);
      setPineLabActive(res.data.isPineLabActive);
      setIsPhonePayActive(res.data.isPhonePayActive);
      setIsAirPayActive(res.data.isAirPayActive);
      setIsMyPayActive(res.data.isMyPayActive);
      setHoadaPaypayInActive(res.data.isHaodaPayPayInActive);
    } catch (e) {}

    if (/Android|webOS|iPhone|iPad|iPod|#fffBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      setMobile(true);
    }
  }
  
  useEffect(() => {
    meeApi()
  }, []);

  const handleImageDownload = (item) => {
    const link = document.createElement("a");
    link.href = item;
    link.download = "QR-Code.png";
    link.click();
  };

  const clearImage = (e) => {
    setScrnshot1(null);
    setScrnshot(null);
  };

  const handleChange = (e) => {
    setScrnshot1(URL.createObjectURL(e.target.files[0]));
    const image = e.target.files[0];
    if (image && image.size / 1000 > 300) {
      new Compressor(image, {
        quality: 0.6,
        success(compressedResult) {
          if (compressedResult) {
            setScrnshot(compressedResult);
          } else {
            setScrnshot(image);
          }
        },
      });
    } else {
      setScrnshot(e.target.files[0]);
    }
  };

  const ManualPayment = async () => {
    const access_token = localStorage.getItem("token");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${access_token}`);

    try {
      const result = await apiRequest("gatewaysettings/data", "GET", null, myHeaders)
      setManualData(result.data);
      setPaynow1Url(result?.data?.paynow1Url);
      setPayOneImage(result?.data?.isPayOneImage);
      setPayTwoImage(result?.data?.isPayTwoImage);
      setPayThreeImage(result?.data?.isPayThreeImage);
      setPayFourImage(result?.data?.isPayFourImage);
      setPayFiveImage(result?.data?.isPayFiveImage);
      setIsMyPayActive(result?.data?.isMypayInActive)
      setPayinOne(result?.data?.payinOne)
      setPayinTwo(result?.data?.payinTwo)
      setUpiGateway(result?.data?.isUpiGateway)
      setUpiGateway02(result?.data?.isUpiGateway02)
      setUpiGateway03(result?.data?.isUpiGateway03)
      setPGGateway(result?.data?.isPgUpiGateway);
    } catch (error) {}
  };

  useEffect(() => {
    ManualPayment.apply();
  }, []);

  const [ImageUrl, setImageUrl] = useState("");
  const [PaymentLink, setPaymentLink] = useState("");

  const getImageUrl = (image, url) => {
    setImageUrl(image);
    setPaymentLink(url);
  };

  const copyCode = (e) => {
    navigator.clipboard.writeText(PayNow1Url);
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Link Copied",
      showConfirmButton: false,
      timer: 1200,
      background: '#1a1a2e',
      color: '#fff',
    });
  };

  const copyCode1 = (e) => {
    navigator.clipboard.writeText(manualData?.acNo);
    Swal.fire({ position: "center", icon: "success", title: "Account Number Copy", showConfirmButton: false, timer: 1200, background: '#1a1a2e', color: '#fff' });
  };
  const copyCode2 = (e) => {
    navigator.clipboard.writeText(manualData?.acName);
    Swal.fire({ position: "center", icon: "success", title: "Name Copy", showConfirmButton: false, timer: 1200, background: '#1a1a2e', color: '#fff' });
  };
  const copyCode3 = (e) => {
    navigator.clipboard.writeText(manualData?.ifsccode);
    Swal.fire({ position: "center", icon: "success", title: "IFSC Code Copy", showConfirmButton: false, timer: 1200, background: '#1a1a2e', color: '#fff' });
  };

  const payinnn = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const res = await apiRequest('zap-upigateway', "POST", { amount: global }, headers)
    setProcess(false);
    if (res.data.status == false) {
      setProcess(false);
      Swal.fire({ title: res.data.msg, icon: "danger", confirmButtonText: "OK" });
    } else if (res.data) {
      setProcess(false);
      let order_id = res.data.txnID;
      let order_token = res.data.paymentReferenceId;
      if (res.data) {
        setProcess(false);
        window.open(res.data?.data?.payment_url, "_blank");
      }
    } else {
      setProcess(false);
      Swal.fire({ title: res.data.status, icon: "danger", confirmButtonText: "OK" });
    }
  };

  const paymy = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const res = await apiRequest('camlenio/payin01', "POST", { amount: global }, headers)
    setProcess(false);
    if (res.data.status == false) {
      setProcess(false);
      Swal.fire({ title: res.data.msg, icon: "danger", confirmButtonText: "OK" });
    } else if (res.data) {
      setProcess(false);
      let order_id = res.data.txnID;
      let order_token = res.data.paymentReferenceId;
      if (res.data?.payload?.web) {
        setProcess(false);
        window.open(res.data?.payload?.web, "_blank");
      }
    } else {
      setProcess(false);
      Swal.fire({ title: res.data.status, icon: "danger", confirmButtonText: "OK" });
    }
  };

  const ManualPayments = async () => {
    setIsloading1(true);
    var formdata = new FormData();
    formdata.append("Transaction_Screenshot", scrnshot);
    formdata.append("amount", global);
    formdata.append("referenceId", utr);

    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };

    const result = await apiRequest("manual/deposit/txn", "POST", formdata, headers)
    setIsloading1(false);

    if (result?.data?.status === "Pending") {
      Swal.fire({ title: result?.data?.message, icon: "success", confirmButtonText: "OK", background: '#1a1a2e', color: '#fff' });
    } else {
      Swal.fire({ title: result?.data?.message, icon: "error", confirmButtonText: "OK", background: '#1a1a2e', color: '#fff' });
    }
    history.push("/");
    handleClose_won();
  };

  const handleIMBGateway = async () => {
    try {
      const access_token = localStorage.getItem("token");
      const finalAmount = amount || global;
      if (!finalAmount || finalAmount <= 0) {
        return Swal.fire({ title: "Enter valid amount", icon: "warning" });
      }
      const headers = { Authorization: `Bearer ${access_token}` };
      const res = await apiRequest(`imb-request?amount=${finalAmount}`, "GET", null, headers);

      if (res?.data?.status === true && res?.data?.payment_url) {
        Swal.fire({ title: "Redirecting...", icon: "info", timer: 1500, showConfirmButton: false });
        setTimeout(() => { window.location.href = res.data.payment_url; }, 1200);
      } else {
        Swal.fire({ title: res?.data?.msg || "Payment Failed", icon: "error" });
      }
    } catch (err) {
      Swal.fire({ title: "Connection Failed", text: err?.message || "Try again", icon: "error" });
    }
  };

  const translations = {
    hi: { addMoney: 'पैसे जोड़ने के लिए राशि चुनें |', money: 'राशि डालें  ', next: 'आगे बड़े ', addAmount: 'राशि जोड़ी जानी है ', referPerson: 'रेफ़रल | ' },
    en: { addMoney: 'Choose Amount To Add', money: 'Enter Amount', next: 'Next', addAmount: 'Amount to be added', referPerson: 'Referral' },
  };

  const { language } = useContext(LanguageContext);

  return (
    <>
      <Header user={userAllData} />

      <style>
        {`
          .premium-deposit-container {
            background: linear-gradient(135deg, #0a0f1c 0%, #000000 100%);
            min-height: 112vh;
            color: #ffffff;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            overflow-x: hidden;
            padding-bottom: 50px;
          }
          
          .slide-up {
            animation: slideUp 0.6s ease-out forwards;
          }

          .glass-card {
            background: rgba(20, 25, 40, 0.7);
            backdrop-filter: blur(10px);
            border-radius: 12px;
            border: 1px solid rgba(255, 255, 255, 0.08);
            box-shadow: 0 15px 35px rgba(0,0,0,0.5);
            transition: all 0.3s ease;
            padding: 25px;
            margin-bottom: 20px;
          }

          .premium-input-wrapper {
            position: relative;
            margin: 20px 0;
          }

          .premium-input-wrapper input {
            width: 100%;
            background: rgba(0,0,0,0.4);
            border: 1px solid rgba(255,255,255,0.1);
            color: #f0c022;
            padding: 18px 15px 18px 50px;
            border-radius: 10px;
            font-size: 22px;
            font-weight: bold;
            transition: all 0.3s ease;
          }

          .premium-input-wrapper input:focus {
            outline: none;
            border-color: #f0c022;
            box-shadow: 0 0 10px rgba(240, 192, 34, 0.2);
          }

          .premium-currency {
            position: absolute;
            left: 20px;
            top: 50%;
            transform: translateY(-50%);
            color: #8892b0;
            font-size: 22px;
            font-weight: bold;
          }

          .quick-add-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 12px;
            margin-bottom: 30px;
          }

          @media (max-width: 600px) {
            .quick-add-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }

          .quick-btn {
            background: rgba(255,255,255,0.05);
            border: 1px solid rgba(255,255,255,0.1);
            color: #ffffff;
            padding: 12px 0;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s;
            font-weight: bold;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          }

          .quick-btn img {
            width: 18px;
            opacity: 0.8;
          }

          .quick-btn:hover {
            background: rgba(240, 192, 34, 0.15);
            border-color: #f0c022;
            color: #f0c022;
            transform: translateY(-2px);
          }

          .premium-btn-gold {
            background: #f0c022;
            color: #000000;
            width: 100%;
            padding: 16px;
            border: none;
            border-radius: 10px;
            font-size: 16px;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 1px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .premium-btn-gold:hover {
            background: #d4a71c;
            transform: translateY(-2px);
          }

          .gateway-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 20px;
            cursor: pointer;
            border-radius: 12px;
            background: rgba(20, 25, 40, 0.7);
            border: 1px solid rgba(255,255,255,0.08);
            margin-bottom: 12px;
            transition: all 0.3s ease;
          }

          .gateway-row:hover {
            background: rgba(0, 136, 204, 0.15);
            border-color: rgba(0, 136, 204, 0.4);
            transform: translateY(-3px);
            box-shadow: 0 5px 15px rgba(0, 136, 204, 0.2);
          }

          .gateway-icon-wrap {
            background: rgba(255, 255, 255, 0.1);
            width: 45px;
            height: 45px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .gateway-text {
            flex: 1;
            margin-left: 15px;
            color: #ffffff;
            font-weight: 700;
            font-size: 15px;
          }

          .gateway-arrow {
            color: #0088cc;
            font-size: 24px;
          }

          .account-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0;
            border-bottom: 1px solid rgba(255,255,255,0.05);
          }

          .account-row:last-child {
            border-bottom: none;
          }

          .account-label {
            color: #8892b0;
            font-size: 13px;
            text-transform: uppercase;
            font-weight: bold;
          }

          .account-value {
            color: #ffffff;
            font-size: 16px;
            font-weight: bold;
          }

          .copy-badge-btn {
            background: rgba(240, 192, 34, 0.15);
            color: #f0c022;
            border: 1px solid rgba(240, 192, 34, 0.3);
            padding: 4px 10px;
            border-radius: 6px;
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
            margin-left: 10px;
            transition: all 0.2s;
          }

          .copy-badge-btn:hover {
            background: rgba(240, 192, 34, 0.3);
          }

          .premium-modal-wrapper .modal-content {
            background: #141928 !important;
            border: 1px solid rgba(255,255,255,0.1) !important;
            color: #ffffff;
            border-radius: 12px;
          }

          .premium-modal-wrapper .modal-header {
            border-bottom: 1px solid rgba(255,255,255,0.05);
          }

          .premium-modal-wrapper .close {
            color: #ffffff;
            text-shadow: none;
          }

          .premium-modal-wrapper input {
            background: rgba(0,0,0,0.5) !important;
            border: 1px solid rgba(255,255,255,0.1) !important;
            color: #ffffff !important;
            padding: 12px;
            border-radius: 8px;
            width: 100%;
          }

          @keyframes slideUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>

      <div className="premium-deposit-container leftContainer mt-5 pt-5" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 100%', maxWidth: '650px', margin: '0 auto', padding: '20px' }}>

          {!process1 && (
            <div>
              {/* STEP 1: ENTER AMOUNT */}
              {next == 1 && (
                <div className="glass-card slide-up">
                  <div style={{ textAlign: 'center', marginBottom: '25px' }}>
                    <h2 style={{ fontSize: '26px', fontWeight: 'bold', margin: '0 0 5px 0', textTransform: 'uppercase', letterSpacing: '1px' }}>
                      Add <span style={{ color: '#f0c022' }}>Funds</span>
                    </h2>
                    <p style={{ color: '#8892b0', fontSize: '13px', margin: '0' }}>{translations[language].addMoney}</p>
                  </div>

                  <div className="premium-input-wrapper">
                    <span className="premium-currency">₹</span>
                    <input
                      type="tel"
                      id="amountInput"
                      placeholder="Enter amount"
                      value={global}
                      onChange={(e) => {
                        e.target.value > 0
                          ? e.target.value <= 50000
                            ? setGlobal(parseInt(e.target.value))
                            : setGlobal(50000)
                          : e.target.value < 0
                            ? setGlobal(10)
                            : setGlobal(0);
                      }}
                    />
                  </div>

                  <div className="quick-add-grid">
                    <button className="quick-btn" onClick={() => setGlobal(100)}>
                      <img src="/Coin without Glow.gif" alt="Coin" /> 100
                    </button>
                    <button className="quick-btn" onClick={() => setGlobal(250)}>
                      <img src="/Coin without Glow.gif" alt="Coin" /> 250
                    </button>
                    <button className="quick-btn" onClick={() => setGlobal(500)}>
                      <img src="/Coin without Glow.gif" alt="Coin" /> 500
                    </button>
                    <button className="quick-btn" onClick={() => setGlobal(2000)}>
                      <img src="/Coin without Glow.gif" alt="Coin" /> 2000
                    </button>
                  </div>

                  {addCaseSetting.isDeposit ? (
                    <button type="button" id="addcase" className="premium-btn-gold" onClick={handleNext}>
                      {translations[language].next} <BsArrowRight style={{ fontSize: '20px' }} />
                    </button>
                  ) : (
                    <div style={{ background: 'rgba(255,0,0,0.1)', color: '#ff4d4d', padding: '15px', borderRadius: '8px', textAlign: 'center', fontWeight: 'bold' }}>
                      Deposit services Closed for some time
                    </div>
                  )}
                </div>
              )}

              {/* STEP 2: SELECT GATEWAY */}
              {next == 2 && (
                <div className="slide-up">
                  <div className="glass-card" style={{ padding: '15px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <span style={{ color: '#8892b0', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Amount to be added</span>
                      <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#f0c022' }}>₹ {global}</div>
                    </div>
                    <button onClick={() => setNext(1)} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>
                      Edit
                    </button>
                  </div>

                  <h4 style={{ fontSize: '16px', color: '#8892b0', marginTop: '20px', marginBottom: '15px', textTransform: 'uppercase', letterSpacing: '1px' }}>
                    Select Payment Method
                  </h4>

                  {/* PhonePe */}
                  {isPhonePayActive && (
                    <div onClick={() => fetchPaymentUrl()} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">Pay Now 1</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {/* UPI Gateway 1 */}
                  {global >= manualData?.upiGatewayMin && isUpiGateway && global <= manualData?.upiGatewayMax && (
                    <div onClick={() => handleIMBGateway()} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">Pay Qr Code</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {/* UPI Gateway 2 */}
                  {global >= manualData?.upiGatewayMin2 && isUpiGateway02 && global <= manualData?.upiGatewayMax2 && (
                    <div onClick={() => upigateway02()} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">Pay Qr Code 2</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {/* UPI Gateway 3 */}
                  {global >= manualData?.upiGatewayMin3 && isUpiGateway03 && global <= manualData?.upiGatewayMax3 && (
                    <div onClick={() => pgupigateway()} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">Pay Qr Code 3</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {/* Air Pay 1 */}
                  {global >= manualData?.payinMin && payinOne && global <= manualData?.payinMax && (
                    <div onClick={() => payinnn()} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">Pay Now</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {/* Air Pay 2 */}
                  {global >= manualData?.payinMin && payinTwo && global <= manualData?.payinMax && (
                    <div onClick={() => paymy()} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">Pay Now 2</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {/* Account Payment */}
                  {manualData?.isAccountActive && global >= manualData?.upiMin && global <= manualData?.upiMax && (
                    <div onClick={() => setNext(4)} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/images/Bank.png" width="24px" alt="Bank" /></div>
                      <div className="gateway-text">Pay With Account</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {/* QR Codes 1 to 5 */}
                  {manualData?.isPayNowOne && global >= manualData?.upiMin && global <= manualData?.upiMax && (
                    <div onClick={() => { setNext(3); getImageUrl(PayOneImage, PayNow1Url); }} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">QR CODE 1</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {manualData?.isPayNowTwo && (
                    <div onClick={() => { setNext(3); getImageUrl(PayTwoImage, PayNow2Url); }} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">QR CODE 2</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {manualData?.isPayNowThree && (
                    <div onClick={() => { setNext(3); getImageUrl(PayThreeImage, PayNow3Url); }} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">QR CODE 3</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {manualData?.isPayNowFour && (
                    <div onClick={() => { setNext(3); getImageUrl(PayFourImage, PayNow4Url); }} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">QR CODE 4</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {manualData?.isPayNowFive && (
                    <div onClick={() => { setNext(3); getImageUrl(PayFiveImage, PayNow5Url); }} className="gateway-row">
                      <div className="gateway-icon-wrap"><img src="/UPI.png" width="24px" alt="UPI" /></div>
                      <div className="gateway-text">QR CODE 5</div>
                      <BsArrowRight className="gateway-arrow" />
                    </div>
                  )}

                  {/* WhatsApp Payment */}
                  {global >= manualData?.whatsappRangemin && manualData?.whatsappDeposit && global <= manualData?.whatsappRangemax && (
                    <div className="glass-card text-center" style={{ marginTop: '20px' }}>
                      <h4 style={{ color: '#8892b0', fontSize: '14px' }}>Payment Amount</h4>
                      <h5 style={{ color: '#00ff88', fontSize: '24px', fontWeight: 'bold' }}>₹ {global}</h5>
                      <p style={{ fontSize: '13px', color: '#cbd5e0', margin: '15px 0' }}>{addCaseSetting?.whatsappDepositmsg}</p>
                      
                      <a href={`https://wa.me/+91${addCaseSetting?.whatsappDepositNo}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', background: '#25D366', color: '#fff', padding: '12px 25px', borderRadius: '8px', textDecoration: 'none', fontWeight: 'bold' }}>
                        <BsWhatsapp style={{ fontSize: '20px' }} /> WhatsApp Pay
                      </a>
                    </div>
                  )}
                </div>
              )}

              {/* STEP 3: QR CODE PAYMENT */}
              {next == 3 && (
                <div className="slide-up">
                  <div style={{ background: 'rgba(240, 192, 34, 0.1)', borderLeft: '4px solid #f0c022', padding: '15px', borderRadius: '4px', marginBottom: '20px', fontSize: '13px', lineHeight: '1.6' }}>
                    कृपया सुनिश्चित करें कि आप <strong>मैन्युअल डिपॉजिट अमाउंट</strong> के बराबर ही भुगतान करें। <strong>UTR नंबर</strong> और <strong>स्क्रीनशॉट</strong> के बिना पेमेंट ऐड नहीं होगा।
                  </div>

                  <div className="glass-card text-center">
                    <h4 style={{ color: '#fff', fontSize: '18px', marginBottom: '20px' }}>💰 Scan and Pay Instantly</h4>
                    
                    <div style={{ background: '#fff', padding: '15px', borderRadius: '12px', display: 'inline-block', marginBottom: '20px' }}>
                      <img src={baseUrl + `/${ImageUrl}`} alt="QR Code" style={{ width: '200px', height: '200px', objectFit: 'contain' }} />
                    </div>

                    <div style={{ background: 'rgba(0,0,0,0.4)', padding: '12px', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
                      <span style={{ color: '#8892b0', fontSize: '13px', wordBreak: 'break-all', textAlign: 'left' }}>{PayNow1Url}</span>
                      <button className="copy-badge-btn" onClick={copyCode}>Copy</button>
                    </div>

                    <button className="premium-btn-gold" onClick={handleShow_won}>
                      ✅ Upload Payment Details
                    </button>
                  </div>
                </div>
              )}

              {/* STEP 4: MANUAL BANK ACCOUNT */}
              {next == 4 && (
                <div className="slide-up">
                  <div style={{ background: 'rgba(240, 192, 34, 0.1)', borderLeft: '4px solid #f0c022', padding: '15px', borderRadius: '4px', marginBottom: '20px', fontSize: '13px', lineHeight: '1.6' }}>
                    अगर कोई यूजर मैन्युअल डिपॉजिट अमाउंट जितना पे करता है उतना ही पेमेंट डालकर UTR नंबर और स्क्रीनशॉट सबमिट करें। पेमेंट कम या ज्यादा डालने पर डिपॉजिट ऐड नहीं होगा।
                  </div>

                  <div className="glass-card">
                    <div className="account-row">
                      <span className="account-label">Account Number</span>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="account-value">{manualData?.acNo || 'N/A'}</span>
                        <button className="copy-badge-btn" onClick={copyCode1}>Copy</button>
                      </div>
                    </div>
                    <div className="account-row">
                      <span className="account-label">Beneficiary Name</span>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="account-value">{manualData?.acName || 'N/A'}</span>
                        <button className="copy-badge-btn" onClick={copyCode2}>Copy</button>
                      </div>
                    </div>
                    <div className="account-row">
                      <span className="account-label">IFSC Code</span>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="account-value">{manualData?.ifsccode || 'N/A'}</span>
                        <button className="copy-badge-btn" onClick={copyCode3}>Copy</button>
                      </div>
                    </div>
                  </div>

                  <div style={{ textAlign: 'center', marginBottom: '25px', color: '#8892b0', fontSize: '13px' }}>
                    <strong>NOTE:</strong> पेमेंट सक्सेस होने के बाद स्क्रीनशॉट और UTR नंबर सबमिट करें।
                  </div>

                  <button className="premium-btn-gold" onClick={handleShow_won}>
                    📤 Upload Payment Details
                  </button>
                </div>
              )}
            </div>
          )}

          {process1 && (
            <div className="loaderReturn" style={{ zIndex: "99" }}>
              <img src={"/images/LandingPage_img/loaderred.gif"} style={{ width: "100%" }} />
            </div>
          )}

        </div>
      </div>

      {/* Upload Modal */}
      <Modal
        show={show_won}
        onHide={handleClose_won}
        className="premium-modal-wrapper"
        centered
      >
        <Modal.Header closeButton>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>Payment Details</h3>
        </Modal.Header>
        <Modal.Body style={{ padding: '25px' }}>
          <div>
            <label style={{ color: '#8892b0', fontSize: '12px', fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>AMOUNT</label>
            <input
              type="number"
              value={global}
              readOnly
              style={{ marginBottom: '20px' }}
            />
            
            <label style={{ color: '#8892b0', fontSize: '12px', fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>UTR NUMBER</label>
            <input
              type="text"
              value={utr}
              onChange={(e) => setutr(e.target.value)}
              placeholder="Enter 12-digit UTR Number"
              style={{ marginBottom: '20px' }}
            />

            <div style={{ border: '1px dashed rgba(240, 192, 34, 0.5)', borderRadius: '10px', padding: '20px', textAlign: 'center', position: 'relative', background: 'rgba(0,0,0,0.3)', marginBottom: '20px' }}>
              <input
                type="file"
                onChange={handleChange}
                accept="image/*"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }}
              />
              {!scrnshot ? (
                <div style={{ color: '#f0c022', fontWeight: 'bold' }}>📸 Tap to Upload Screenshot</div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', zIndex: 2, position: 'relative' }}>
                  <div style={{ color: '#fff', fontSize: '13px', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '80%' }}>
                    {scrnshot.name} ({(scrnshot.size / 1024 / 1024).toFixed(2)} MB)
                  </div>
                  <button onClick={() => { clearImage(); }} style={{ background: 'red', color: '#fff', border: 'none', borderRadius: '50%', width: '24px', height: '24px', cursor: 'pointer' }}>✖</button>
                </div>
              )}
            </div>

            {scrnshot1 && (
              <div style={{ width: "100%", marginBottom: "20px", borderRadius: '8px', overflow: 'hidden' }}>
                <img src={scrnshot1} style={{ width: "100%" }} alt="Screenshot Preview" />
              </div>
            )}

            {!fecthStatus && (
              <>
                {isLoading1 ? (
                  <button className="premium-btn-gold" disabled style={{ opacity: 0.7 }}>
                    <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" style={{ marginRight: '10px' }} />
                    Loading...
                  </button>
                ) : (
                  <button className="premium-btn-gold" onClick={ManualPayments} disabled={!utr || !scrnshot}>
                    SUBMIT
                  </button>
                )}
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <div className="rightContainer hidden-mobile mobile-hide">
        <Rightcontainer />
      </div>
    </>
  );
};

export default Addcase;